import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
import { id } from 'date-fns/locale';

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    dataDetalle: [],
    fc_36Detalle: {},
    fc_36: {
        fechasolicitud: fechaHoy,
        nocliente: '',

        cambiorazon: false,
        actualizacioncadena: false,
        actualizacionmarca: false,
        actualizaciondomicilio: false,
        cambioresponsable: false,
        cambiorepresentante: false,
        medioscontacto: false,
        cambioresponsableinst: false,
        actualizarmarcas: false,
        certificadonomproductor: false,
        certificadonomenvasador: false,
        certificadonomcomercializador: false,
        productormaguey: false,
        productormezcal: false,
        envasador: false,
        comercializadormezcal: false,
        comercializadorbebidas: false,
        actualizacioninstalaciones: false,
        actualizacionprediosviveros: false,

        nombrerazonsocial: '',
        rfc: '',
        tipoempresa: '',
        actualizacionnombrerazon: '',
        certificacionsi: false,
        certificacionno: false,
        empresacertificadora: '',
        numerohombres: '',
        numeromujeres: '',
        numerodiscapacitados: '',
        numerobase: '',
        numeroeventuales: '',

        fechadenacimiento: '',
        sexo: '',
        estadocivil: '',
        escolaridad: '',
        tipodiscapacidad: '',
        discapacidadsi: false,
        discapacidadno: false,
        lenguaindijenasi: false,
        lenguaindijenano: false,
        tipolengua: '',
        ocupacion: '',
        numerohijos: 0,

        altainfraestructura: false,
        bajainfraestructura: false,

        medioscontactosi: false,
        medioscontactono: false,
        repesentantelegalsi: false,
        repesentantelegalno: false,
        personaautorizadasi: false,
        personaautorizadano: false,
        domiciliofiscalsi: false,
        domiciliofiscalno: false,
        actualizacionprediossi: false,
        actualizacionprediosno: false,
        actualizacionviverossi: false,
        actualizacionviverosno: false,
        actualizacioninstalacionsi: false,
        actualizacioninstalacionno: false,



    },
    loading: false,
    anexoUnidadProduccion: [],
    anexoUnidadEnvasado: [],
    anexoUnidadAlmacen: [],
    anexoMarcas: [],
    anexoContactos: [],
    anexoRepresentantes: [],
    anexoUnidadProduccionBaja: [],
    anexoUnidadEnvasadoBaja: [],
    anexoUnidadAlmacenBaja: [],
    anexoMarcasBaja: [],
    anexoContactosBaja: [],
    anexoRepresentantesBaja: [],
    fc_36Map: {},
    anexoUnidadProduccionMap: {},
    anexoUnidadEnvasadoMap: {},
    anexoUnidadAlmacenMap: {},
    anexoMarcasMap: [],

    anexoRepresentantesMap: [],
    anexoMarcasBajaMap: [],
    anexoContactosBajaMap: [],
    anexoRepresentantesBajaMap: [],
    paginaActiva: 1,
    paginaActivaProduccion: 1,
    paginaActivaEnvasado: 1,
    paginaActivaAlmacen: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,

    anexoContactosMap: [],
    anexoRepresentantesMap: [],
    anexoArchivosRepresentantesMap: [],
    anexoPersonaAutorizadaMap: [],
    anexoArchivosPersonaAutorizadaMap: [],
    anexoDomicilioFiscalMap: [],
    anexoArchivosDomicilioFiscalMap: [],
    anexoPrediosMap: [],
    anexoArchivosPrediosMap: [],
    anexoViverosMap: [],
    anexoArchivosViverosMap: [],
    anexoMarcasMap: [],
    anexoArchivosMarcasMap: [],
    anexoMarcasBebidaMap: [],
    anexoArchivosMarcasBebidaMap: [],
    anexoInstalacionesMap: [],
    anexoArchivosInstalacionesMap: [],
    anexoResponsablesInstalacionesMap: [],
    anexoArchivosResponsablesInstalacionesMap: [],
    anexoResponsablesInstMap: [],
    anexoArchivosResponsablesInstMap: [],

    dataDocumentacion: [],

    datosLogin: [],
    mediosContactoRelacionada: [],
    mediosContactoDetalle: [],
    mediosContacto: [],
    apoderadosDetalle: [],
    apoderadosLegales: [],
    personasAutorizadasDetalle: [],
    personasAutorizadas: [],
    domiciliosFiscalesDetalle: [],
    domiciliosFiscales: [],
    marcasDetalle: [],
    marcas: [],
    marcasBebidasDetalle: [],
    marcasBebidas: [],
    tipoInstalacionesDetalle: [],
    tipoInstalaciones: [],
    aliasInstalacionesDetalle: [],
    aliasInstalaciones: [],
    responsablesInstalacionesDetalle: [],
    responsablesInstalaciones: [],
    prediosDetalle: [],
    predios: [],
    viverosDetalle: [],
    viveros: [],
    opcionesFilePredio: [],
    opcionesFileVivero: [],

    filesApoderados: [],
    filesPersonasAutorizadas: [],
    filesDomiciliosFiscales: [],
    filesViveros: [],
    filesPredios: [],
    filesActualizacionResponsables: [],
    filesMarcas: [],
    filesMarcasBebidas: [],
    cliente: [],

    instalacionesDetalle: [],
    instalaciones: [],
    anexoUnidadMap: [],
    anexoResponsableMap: [],
    seccionesAlmacen: [],
    actividadesEmpresa: {},
    domicilioFiscal: {},
    numeroDeUnidades: 0,
    seccionesProduccion: [],
    dataSeccionesProduccion: [],
    seccionesEnvasado: [],
    documentacionInstalacionMap: [],
    documentacionResponsableMap: [],
    filesInstalaciones: [],
    filesResponsables: [],
    filesGenerales: [],
    opcionesFilesInstalaciones: [],
    documentacionMarcaMap: [],
    documentacionMarcaProductoMap: [],
    estadosDenominacionOrigen: [
        'Oaxaca',
        'Guerrero',
        'San Luis Potosí',
        'Zacatecas',
        'Durango'
    ],
    estadosDenominacion: [
        'Tamaulipas',
        'Guanajuato',
        'Michoacán de Ocampo',
        'Puebla',
    ],
    municipiosTamaulipas: [
        'San Carlos',
        'San Nicolás',
        'Burgos',
        'Miquihuana',
        'Bustamante',
        'Palmillas',
        'Jaumave',
        'Tula',
        'Cruillas',
        'Jiménez',
        'Méndez'
    ],
    municipiosGuanajuato: [
        'San Felipe',
        'San Luis de la Paz',
    ],
    municipiosMichoacan: [
        'Acuitzio',
        'Aguililla',
        'Ario',
        'Buenavista',
        'Charo',
        'Chinicuila',
        'Coalcomán de Vázquez Pallares',
        'Cotija',
        'Cojumatlán de Régules',
        'Erongarícuaro',
        'La Huacana',
        'Tacámbaro',
        'Turicato',
        'Tzitzio',
        'Hidalgo',
        'Salvador Escalante',
        'Morelia',
        'Madero',
        'Queréndaro',
        'Indaparapeo',
        'Tarímbaro',
        'Tancítaro',
        'Los Reyes',
        'Tepalcatepec',
        'Sahuayo',
        'Marcos Castellanos',
        'Jiquilpan',
        'Venustiano Carranza',
        'Vista Hermosa',
    ],
    municipiosPuebla: [
        'Acajete',
        'Acatlán de Osorio',
        'Acatzingo',
        'Acteopan',
        'Ahuatlán',
        'Ahuehuetitla',
        'Ajalpan',
        'Albino Zertuche',
        'Altepexi',
        'Amozoc',
        'Aquixtla',
        'Atexcal',
        'Atlixco',
        'Atoyatempan',
        'Atzala',
        'Axutla',
        'Caltepec',
        'Coatzingo',
        'Cohetzala',
        'Cohuecán',
        'Coxcatlán',
        'Coyomeapan',
        'Coyotepec',
        'Cuapiaxtla de Madero',
        'Cuautinchan',
        'Cuayuca de Andrade',
        'Cuyoaco',
        'Chapulco',
        'Chiautla',
        'Chietla',
        'Chigmecatitlan',
        'Chignahuapan',
        'Chila',
        'Chila de la Sal',
        'Chinantla',
        'Eloxochitlán',
        'Epatlán',
        'General Felipe Ángeles',
        'Guadalupe',
        'Huatlatlauca',
        'Huehuetlán el Chico',
        'Huehuetlán el Grande',
        'Huitziltepec',
        'Ixcamilpa de Guerrero',
        'Ixcaquixtla',
        'Ixtacamaxtitlán',
        'Izucar de Matamoros',
        'Jolalpan',
        'Juan N. Méndez',
        'La Magdalena Tlatlauquitepec',
        'Libres',
        'Los Reyes de Juárez',
        'Mixtla',
        'Molcaxac',
        'Nicolás Bravo',
        'Nopalucan',
        'Ocotepec',
        'Oriental',
        'Palmar de Bravo',
        'Petlalcingo',
        'Piaxtla',
        'Quecholac',
        'Rafael Lara Grajales',
        'San Antonio Cañada',
        'San Diego la Mesa Tochimiltzingo',
        'San Gabriel Chilac',
        'San Jerónimo Xayacatlán',
        'San José Chiapa',
        'San José Miahuatlán',
        'San Juan Atzompa',
        'San Martín Totoltepec',
        'San Miguel Ixitlán',
        'San Pablo Anicano',
        'San Pedro Yeloixtlahuaca',
        'San Salvador Huixcolotla',
        'San Sebastián Tlacotepec',
        'Santa Catarina Tlaltempan',
        'Santa Inés Ahuatempan',
        'Santiago Miahuatlán',
        'Santo Tomás Hueyotlipan',
        'Tecali de Herrera',
        'Tecamachalco',
        'Tecomatlán',
        'Tehuacán',
        'Tehuitzingo',
        'Teopantlán',
        'Teotlalco',
        'Tepanco de López',
        'Tepatlaxco de Hidalgo',
        'Tepeaca',
        'Tepemaxalco',
        'Tepeojuma',
        'Tepexco',
        'Tepexi de Rodríguez',
        'Tepeyahualco',
        'Tepeyahualco de Cuauhtémoc',
        'Tilapa',
        'Tlacotepec de Benito Juárez',
        'Tlanepantla',
        'Tlapanalá',
        'Tochimilco',
        'Tochtepec',
        'Totoltepec de Guerrero',
        'Tulcingo',
        'Tzicatlacoyan',
        'Vicente Guerrero',
        'Xayacatlán de Bravo',
        'Xicotlan',
        'Xochitlán Todos Santos',
        'Yehualtepec',
        'Zacapala',
        'Zapotitlán Salinas',
        'Zautla',
        'Zinacatepec',
        'Zoquitlán',
        'Xochiltepec',
    ],
}

//types
const OBTENER_FC_36_DETALLE_EXITO = 'OBTENER_FC_36_DETALLE_EXITO'
const OBTENER_FC_36_MAP_EXITO_CLIENTE = 'OBTENER_FC_36_MAP_EXITO_CLIENTE'
const OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO'
const OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO'
const OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO = 'OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO'
const FC_36_SOLICITUD_EXITO = 'FC_36_SOLICITUD_EXITO'
const AGREGAR_FC_36_BORRADOR_EXITO = 'AGREGAR_FC_36_BORRADOR_EXITO'
const ACTUALIZAR_FC_36_ESTATUS_EXITO = 'ACTUALIZAR_FC_36_ESTATUS_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADALMACEN_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADALMACEN_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADENVASADO_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADENVASADO_EXITO'
const ELIMINAR_FC_36_ANEXOUNIDADPRODUCCION_EXITO = 'ELIMINAR_FC_36_ANEXOUNIDADPRODUCCION_EXITO'
const ELIMINAR_FC_36_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_36_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_36_ANEXOMARCA_EXITO_BD = 'ELIMINAR_FC_36_ANEXOMARCA_EXITO_BD'
const ELIMINAR_FC_36_ANEXOREPRESENTANTE_EXITO_BD = 'ELIMINAR_FC_36_ANEXOREPRESENTANTE_EXITO_BD'
const ELIMINAR_FC_36_ANEXOCONTACTO_EXITO_BD = 'ELIMINAR_FC_36_ANEXOCONTACTO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_36 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_36'
const OBTENER_FC_36_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_36_CONTADOR_FECHA_FOLIO_EXITO'
const ELIMINAR_FC_46_ANEXO_MEDIO_CONTACTO_EXITO_BD = 'ELIMINAR_FC_46_ANEXO_MEDIO_CONTACTO_EXITO_BD'
const ACTUALIZAR_FC_36_BORRADOR_EXITO = 'ACTUALIZAR_FC_36_BORRADOR_EXITO'
const ELIMINAR_FC_46_ANEXO_REPRESENTANTE_LEGAL_EXITO_BD = 'ELIMINAR_FC_46_ANEXO_REPRESENTANTE_LEGAL_EXITO_BD'
const AGREGAR_ARCHIVO_FC_36_EXITO = 'AGREGAR_ARCHIVO_FC_36_EXITO'
const ACTUALIZAR_ARCHIVO_FC_36_EXITO = 'ACTUALIZAR_ARCHIVO_FC_36_EXITO'
const ELIMINAR_FC_46_ANEXO_PERSONA_AUTORIZADA_EXITO_BD = 'ELIMINAR_FC_46_ANEXO_PERSONA_AUTORIZADA_EXITO_BD'
const OBTENER_FC_36_SECCIONESUNIDADENVASADO_EXITO = 'OBTENER_FC_36_SECCIONESUNIDADENVASADO_EXITO'
const OBTENER_FC_36_SECCIONES_EXITO_BD = 'OBTENER_FC_36_SECCIONES_EXITO_BD'
const OBTENER_FC_36_SECCIONESUNIDADALMACEN_EXITO = 'OBTENER_FC_36_SECCIONESUNIDADALMACEN_EXITO'
const ELIMINAR_ARCHIVO_FC_36_EXITO = 'ELIMINAR_ARCHIVO_FC_36_EXITO'


export const ObtenerClientePorLogin36 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_36,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClienteByIdLogin/${params.idlogin}`
            const res = await axios.get(fullUrl)
            res.data.data.cliente[0].viverista = false
            res.data.data.cliente[0].productormaguey = false
            res.data.data.cliente[0].productormezcal = false
            res.data.data.cliente[0].envasador = false
            res.data.data.cliente[0].comercializadormezcal = false
            res.data.data.cliente[0].comercializadorbebidasmezcal = false
            const cliente = res.data.data.cliente[0]
            let tipoempresa = ''
            if (cliente.personafisica) tipoempresa = 'fisica'
            if (cliente.personamoral) tipoempresa = 'moral'
            let empresacertificadora = ''
            let certificacionno = false
            let certificacionsi = false
            if (cliente.empresacertificadora != null || cliente.empresacertificadora != undefined) {
                empresacertificadora = cliente.empresacertificadora
                certificacionsi = true
                certificacionno = false
            } else {
                empresacertificadora = ''
                certificacionsi = false
                certificacionno = true
            }
            let viverista = false
            let productormaguey = false
            let productormezcal = false
            let envasador = false
            let comercializadormezcal = false
            let comercializadorbebidas = false
            for (const i in cliente.actividadcliente) {
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 1) {
                    viverista = true
                    res.data.data.cliente[0].viverista = true
                }
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 2) {
                    productormaguey = true
                    res.data.data.cliente[0].productormaguey = true
                }
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 3) {
                    productormezcal = true
                    res.data.data.cliente[0].productormezcal = true
                }
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 4) {
                    envasador = true
                    res.data.data.cliente[0].envasador = true
                }
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 5) {
                    comercializadormezcal = true
                    res.data.data.cliente[0].comercializadormezcal = true
                }
                if (cliente.actividadcliente?.[i]?.idtipoactividad == 6) {
                    comercializadorbebidas = true
                    res.data.data.cliente[0].comercializadorbebidasmezcal = true
                }
            }

            let fc_36 = {
                fechasolicitud: fechaHoy, nocliente: '', cambiorazon: false, actualizacioncadena: false,
                actualizacionmarca: false, actualizaciondomicilio: false, cambioresponsable: false,
                cambiorepresentante: false, medioscontacto: false,
                cambioresponsableinst: false, actualizarmarcas: false, certificadonomproductor: false, certificadonomenvasador: false,
                certificadonomcomercializador: false, viverista: viverista, productormaguey: productormaguey, productormezcal: productormezcal,
                envasador: envasador, comercializadormezcal: comercializadormezcal, comercializadorbebidas: comercializadorbebidas,

                nombrerazonsocial: '', rfc: cliente?.rfc, tipoempresa: tipoempresa,
                actualizacionnombrerazon: cliente?.nombrerazonsocial, certificacionsi: certificacionsi,
                certificacionno: certificacionno, empresacertificadora: empresacertificadora,
                numerohombres: cliente?.estadisticasocialcliente?.[0]?.numerohombres,
                numeromujeres: cliente?.estadisticasocialcliente?.[0]?.numeromujeres,
                numerodiscapacitados: cliente?.estadisticasocialcliente?.[0]?.numerodiscapacitados,
                numerobase: cliente?.estadisticasocialcliente?.[0]?.numerobase,
                numeroeventuales: cliente?.estadisticasocialcliente?.[0]?.numeroeventuales,

                fechadenacimiento: '',
                sexo: cliente.informacionpersonafisicacliente?.[0]?.sexo,
                estadocivil: cliente.informacionpersonafisicacliente?.[0]?.estadocivil,
                escolaridad: cliente.informacionpersonafisicacliente?.[0]?.escolaridad,
                tipodiscapacidad: cliente.informacionpersonafisicacliente?.[0]?.tipodiscapacidad,
                discapacidadsi: cliente.informacionpersonafisicacliente?.[0]?.discapacidadsi, discapacidadno: cliente.informacionpersonafisicacliente?.[0]?.discapacidadno,
                lenguaindijenasi: cliente.informacionpersonafisicacliente?.[0]?.lenguaindijenasi, lenguaindijenano: cliente.informacionpersonafisicacliente?.[0]?.lenguaindijenano,
                tipolengua: cliente.informacionpersonafisicacliente?.[0]?.tipolengua,
                ocupacion: cliente.informacionpersonafisicacliente?.[0]?.ocupacion, numerohijos: cliente.informacionpersonafisicacliente?.[0]?.numerohijos,

                altainfraestructura: false, bajainfraestructura: false,
            }


            let idcartera = res.data.data?.cliente?.[0]?.idcartera
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`

            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)

            let mediosContacto = []//res?.data?.data?.cliente?.[0]?.mediosdecontactocliente
            for (const i in res?.data?.data?.cliente?.[0]?.mediosdecontactocliente) {
                let { ...medios } = res?.data?.data?.cliente?.[0]?.mediosdecontactocliente[i]
                if (!medios.isbaja) mediosContacto.push(medios)
            }
            let responsablesLegales = []//res?.data?.data?.cliente?.[0]?.apoderadoslegalescliente
            for (const i in res?.data?.data?.cliente?.[0]?.apoderadoslegalescliente) {
                let { ...apoderado } = res?.data?.data?.cliente?.[0]?.apoderadoslegalescliente[i]
                if (!apoderado.isbaja) responsablesLegales.push(apoderado)
            }
            let representantesAutorizados = []//res?.data?.data?.cliente?.[0]?.representantesautorizadoscliente
            for (const i in res?.data?.data?.cliente?.[0]?.representantesautorizadoscliente) {
                let { ...personas } = res?.data?.data?.cliente?.[0]?.representantesautorizadoscliente[i]
                if (!personas.isbaja) representantesAutorizados.push(personas)
            }

            let domicilioFiscal = []//res?.data?.data?.cliente?.[0]?.domiciliofiscalcliente

            for (const i in res?.data?.data?.cliente?.[0]?.domiciliofiscalcliente) {
                let { ...domicilio } = res?.data?.data?.cliente?.[0]?.domiciliofiscalcliente[i]
                if (!domicilio.isbaja) domicilioFiscal.push(domicilio)
            }



            let anexosInstalaciones = res?.data?.data?.cliente?.[0]?.anexocliente
            let anexosMarcas = res?.data?.data?.cliente?.[0]?.marcascliente
            let anexosMarcasBebidas = res?.data?.data?.cliente?.[0]?.marcasproductoconmezcalcliente
            let anexosViveros = res?.data?.data?.cliente?.[0]?.viverocliente
            let anexosPredios = res?.data?.data?.cliente?.[0]?.prediocliente

            let medios = []
            for (const i in mediosContacto) {
                medios.push({
                    id: uuidv4(), telefono: mediosContacto[i].telefono,
                    correoelectronico: mediosContacto[i].correoelectronico,
                    alta: false, baja: false, idmediosdecontacto: mediosContacto[i].idmediosdecontacto,
                    isbaja: mediosContacto[i].isbaja,
                })
            }

            let apoderados = []
            if (cliente.personamoral) {
                apoderados.push({
                    id: uuidv4(), representantelegal: cliente?.nombrerepresentantelegal,
                    telefono: cliente?.telefonorepresentante, correoelectronico: cliente?.correoelectronicorepresentante,
                    alta: false, baja: false, principal: true, isbaja: false
                })
            }

            for (const i in responsablesLegales) {
                apoderados.push({
                    id: uuidv4(), representantelegal: responsablesLegales[i].representantelegal,
                    telefono: responsablesLegales[i].telefonorepresentante,
                    correoelectronico: responsablesLegales[i].correoelectronicorepresentante,
                    alta: false, baja: false, idapoderadoslegales: responsablesLegales[i].idapoderadoslegales,
                    isbaja: responsablesLegales[i].isbaja, principal: false
                })
            }
            let personasAutorizadas = []
            for (const i in representantesAutorizados) {
                personasAutorizadas.push({
                    id: uuidv4(), personaautoriazadaparatramites: representantesAutorizados[i].personaautoriazadaparatramites,
                    telefono: representantesAutorizados[i].telefonopersona,
                    correoelectronico: representantesAutorizados[i].correoelectronicopersona,
                    alta: false, baja: false, idrepresentantesautorizados: representantesAutorizados[i].idrepresentantesautorizados,
                    isbaja: representantesAutorizados[i].isbaja,
                })
            }
            let domiciliosFiscales = []
            if (domicilioFiscal.length < 2) {
                for (const i in domicilioFiscal) {
                    domiciliosFiscales.push({
                        id: uuidv4(), domicilio: domicilioFiscal[i].calle + ', ' + domicilioFiscal[i].numerointerior + ', ' + domicilioFiscal[i].numeroexterior + ', ' +
                            domicilioFiscal[i].colonia + ', ' + domicilioFiscal[i].localidad + ', ' + domicilioFiscal[i].municipioalcaldia + ', ' + domicilioFiscal[i].estado + ', ' +
                            domicilioFiscal[i].codigopostal,
                        calle: domicilioFiscal[i].calle, numerointerior: domicilioFiscal[i].numerointerior, numeroexterior: domicilioFiscal[i].numeroexterior,
                        colonia: domicilioFiscal[i].colonia, localidad: domicilioFiscal[i].localidad,
                        municipio: domicilioFiscal[i].municipioalcaldia, estado: domicilioFiscal[i].estado,
                        codigopostal: domicilioFiscal[i].codigopostal,
                        alta: false, baja: false, iddomiciliofiscal: domicilioFiscal[i].iddomiciliofiscal,
                        isbaja: domicilioFiscal[i].isbaja, domicilioprincipal: true
                    })
                }
            } else {
                for (const i in domicilioFiscal) {
                    domiciliosFiscales.push({
                        id: uuidv4(), domicilio: domicilioFiscal[i].calle + ', ' + domicilioFiscal[i].numerointerior + ', ' + domicilioFiscal[i].numeroexterior + ', ' +
                            domicilioFiscal[i].colonia + ', ' + domicilioFiscal[i].localidad + ', ' + domicilioFiscal[i].municipioalcaldia + ', ' + domicilioFiscal[i].estado + ', ' +
                            domicilioFiscal[i].codigopostal,
                        calle: domicilioFiscal[i].calle, numerointerior: domicilioFiscal[i].numerointerior, numeroexterior: domicilioFiscal[i].numeroexterior,
                        colonia: domicilioFiscal[i].colonia, localidad: domicilioFiscal[i].localidad,
                        municipio: domicilioFiscal[i].municipioalcaldia, estado: domicilioFiscal[i].estado,
                        codigopostal: domicilioFiscal[i].codigopostal,
                        alta: false, baja: false, iddomiciliofiscal: domicilioFiscal[i].iddomiciliofiscal,
                        isbaja: domicilioFiscal[i].isbaja, domicilioprincipal: domicilioFiscal[i].domicilioprincipal
                    })
                }
            }
            let tipoInstalaciones = []
            for (const i in anexosInstalaciones) {
                let filtro = tipoInstalaciones.filter(anexo => anexo?.idtipoanexo === anexosInstalaciones[i].idtipoanexo)
                if (filtro.length <= 0) tipoInstalaciones.push({ id: uuidv4(), idtipoanexo: anexosInstalaciones[i].idtipoanexo })
            }
            let aliasInstalaciones = []
            for (const i in anexosInstalaciones) {
                let { ...info } = anexosInstalaciones[i].informaciongeneralinstalacioncliente
                if (!anexosInstalaciones[i].isbaja) aliasInstalaciones.push({
                    id: uuidv4(), idtipoanexo: anexosInstalaciones[i].idtipoanexo, alias: anexosInstalaciones[i].informaciongeneralinstalacioncliente.alias,
                    calle: info.calle, numerointerior: info.numerointerior, numeroexterior: info.numeroexterior, colonia: info.colonia,
                    localidad: info.localidad, municipio: info.municipio, estado: info.estado, codigopostal: info.codigopostal
                })
            }
            let responsablesInstalaciones = []

            for (const i in anexosInstalaciones) {
                for (const j in anexosInstalaciones[i].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {
                    let { ...anexo } = anexosInstalaciones[i].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[j]
                    if (!anexosInstalaciones[i].isbaja && !anexo.isbaja) {
                        let numerointerior = ''
                        let numeroexterior = ''
                        let colonia = ''
                        let domicilio = ''
                        if (anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numerointerior != null &&
                            anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numerointerior != undefined
                        ) numerointerior = anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numerointerior

                        if (anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numeroexterior != null &&
                            anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numeroexterior != undefined
                        ) numeroexterior = anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.numeroexterior

                        if (anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.colonia != null &&
                            anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.colonia != undefined
                        ) colonia = anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.colonia

                        domicilio = anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' +
                            colonia + ', ' + anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.localidad + ', ' +
                            anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.municipio + ', ' +
                            anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.estado + ', ' + anexosInstalaciones?.[i].informaciongeneralinstalacioncliente?.codigopostal

                        responsablesInstalaciones.push({
                            id: uuidv4(), idtipoanexo: anexosInstalaciones[i].idtipoanexo, responsableinstalacion: anexo.nombreresponsable,
                            telefono: anexo.telefono, correoelectronico: anexo.correoelectronico, tipoinstalacion: anexosInstalaciones[i].idtipoanexo == 1 ? 'Unidad de Producción' :
                                anexosInstalaciones[i].idtipoanexo == 2 ? 'Unidad de Envasado' : anexosInstalaciones[i].idtipoanexo == 3 ? 'Unidad de Almacén' : '',
                            alias: anexosInstalaciones[i].informaciongeneralinstalacioncliente.alias,
                            idresponsabledeinstalacioncliente: anexo.idresponsabledeinstalacioncliente,
                            isbaja: anexo?.isbaja, alta: false, baja: false, domicilio: domicilio
                        })
                    }
                }
            }

            let viveros = []
            for (const i in anexosViveros) {
                let { ...anexo } = anexosViveros[i]
                if (!anexo.isbaja) viveros.push({
                    id: uuidv4(), nombreparaje: anexo.nombreparaje, estado: anexo.estado,
                    distrito: anexo.distrito, localidad: anexo.localidad, calle: anexo.calle,
                    numeroexterior: anexo.numeroexterior, codigopostal: anexo.codigopostal,
                    domicilio: anexo.numeroexterior + ',' + anexo.calle + ',' + anexo.localidad + ',' + anexo.municipio + ',' +
                        anexo.distrito + ',' + anexo.estado + ',' + anexo.codigopostal,
                    cultivado: anexo.cultivado ? 'Si' : 'No', semicultivado: anexo.semicultivado ? 'Si' : 'No', silvestre: anexo.silvestre ? 'Si' : 'No',
                    idvivero: anexo.idvivero,
                    isbaja: anexo?.isbaja, alta: false, baja: false,
                })
            }
            let predios = []
            for (const i in anexosPredios) {
                let { ...anexo } = anexosPredios[i]
                if (!anexo.isbaja) predios.push({
                    id: uuidv4(), nombreparaje: anexo.nombreparaje, estado: anexo.estado,
                    distrito: anexo.distrito, localidad: anexo.localidad, calle: anexo.calle,
                    numeroexterior: anexo.numeroexterior, codigopostal: anexo.codigopostal,
                    domicilio: anexo.localidad + ',' + anexo.municipio + ',' + anexo.distrito + ',' + anexo.estado,
                    cultivado: anexo.cultivado ? 'Si' : 'No', semicultivado: anexo.semicultivado ? 'Si' : 'No', silvestre: anexo.silvestre ? 'Si' : 'No',
                    idpredio: anexo.idpredio,
                    isbaja: anexo?.isbaja, alta: false, baja: false,
                })
            }
            let numeroInstlaciones = 0
            for (const i in anexosInstalaciones) {
                //if (anexosInstalaciones[i].informaciongeneralinstalacioncliente.instalacionnumero > numeroInstlaciones) numeroInstlaciones = anexosInstalaciones[i].informaciongeneralinstalacioncliente.instalacionnumero
                if (anexosInstalaciones[i].isbaja != true) numeroInstlaciones++
            }

            let anexoInstalaciones = []
            let countInst = 0
            for (const anexo of anexosInstalaciones) {
                anexo.informaciongeneralinstalacioncliente.id = uuidv4()
                anexo.informaciongeneralinstalacioncliente.idcliente = anexo.idcliente
                anexo.informaciongeneralinstalacioncliente.idanexocliente = anexo.idanexocliente
                anexo.informaciongeneralinstalacioncliente.relacioncontacto = anexo.idanexocliente
                anexo.informaciongeneralinstalacioncliente.isbaja = anexo.isbaja
                anexo.informaciongeneralinstalacioncliente.baja = false
                anexo.informaciongeneralinstalacioncliente.alta = false
                let domicilio = ''
                if (anexo.informaciongeneralinstalacioncliente.calle !== null) {
                    if (anexo.informaciongeneralinstalacioncliente.calle === 'Otro') {
                        domicilio += anexo.informaciongeneralinstalacioncliente.otracalle + ', '
                    } else {
                        domicilio += anexo.informaciongeneralinstalacioncliente.calle + ', '
                    }

                }
                if (anexo.informaciongeneralinstalacioncliente.colonia !== null) {
                    domicilio += anexo.informaciongeneralinstalacioncliente.colonia + ', '
                }
                if (anexo.informaciongeneralinstalacioncliente.localidad !== null) {
                    domicilio += anexo.informaciongeneralinstalacioncliente.localidad + ', '
                }
                if (anexo.informaciongeneralinstalacioncliente.municipio !== null) {
                    domicilio += anexo.informaciongeneralinstalacioncliente.municipio + ', '
                }
                if (anexo.informaciongeneralinstalacioncliente.estado !== null) {
                    domicilio += anexo.informaciongeneralinstalacioncliente.estado + ', '
                }
                if (anexo.informaciongeneralinstalacioncliente.codigopostal !== null) {
                    domicilio += anexo.informaciongeneralinstalacioncliente.codigopostal
                }
                if (domicilio === '') domicilio = 'No se asignó un domicilio'
                anexo.informaciongeneralinstalacioncliente.domicilio = domicilio

                for (let i in anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {
                    anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i]['id'] = uuidv4()
                    let estado = await comprobarEmail(anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].correoelectronico)
                    anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i]['estado'] = estado
                }

                const responsables = anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente
                let responsablesInstalaciones = []
                let responsablesValidos = []
                for (const i in responsables) {
                    if (!responsables[i].isbaja) {
                        responsablesValidos.push(responsables[i])
                    }
                }
                delete anexo.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente
                anexo.informaciongeneralinstalacioncliente.responsables = responsablesValidos

                if (anexo.idtipoanexo === 1) {
                    let coccionProduccion = []
                    let moliendaProduccion = []
                    let fermentacionProduccion = []
                    let destilacionProduccion = []
                    let granelProduccion = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelementocliente) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 1:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                coccionProduccion.push(elemento)
                                break
                            case 2:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                moliendaProduccion.push(elemento)
                                break
                            case 3:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                fermentacionProduccion.push(elemento)
                                break
                            case 4:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                destilacionProduccion.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            coccionProduccion,
                            moliendaProduccion,
                            fermentacionProduccion,
                            destilacionProduccion,
                            granelProduccion
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneralinstalacioncliente.dataSeccion = dataSeccion
                        anexo.informaciongeneralinstalacioncliente.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneralinstalacioncliente.instalacionescliente
                    anexo.informaciongeneralinstalacioncliente.tipoInstalacion = 'Unidad Producción'
                    if (!anexo?.informaciongeneralinstalacioncliente?.isbaja) anexoInstalaciones.push({ data: anexo.informaciongeneralinstalacioncliente })
                }
                if (anexo.idtipoanexo === 2) {
                    let seccion1 = []
                    let seccion2 = []
                    let seccion3 = []
                    let seccion4 = []
                    let seccion5 = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelementocliente) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 6:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion1.push(elemento)
                                break
                            case 7:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion2.push(elemento)
                                break
                            case 8:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion3.push(elemento)
                                break
                            case 9:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion4.push(elemento)
                                break
                            case 10:
                                opcionesSeleccionadosSeccion5.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion5.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = { seccion1, seccion2, seccion3, seccion4, seccion5 }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneralinstalacioncliente.dataSeccion = dataSeccion
                        anexo.informaciongeneralinstalacioncliente.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneralinstalacioncliente.instalacionescliente
                    anexo.informaciongeneralinstalacioncliente.tipoInstalacion = 'Unidad Envasado'
                    if (!anexo?.informaciongeneralinstalacioncliente?.isbaja) anexoInstalaciones.push({ data: anexo.informaciongeneralinstalacioncliente })
                }
                if (anexo.idtipoanexo === 3) {
                    let equipoAlmacen = []
                    let maduracionAlmacen = []
                    let variablesAlmacen = []
                    let granelAlmacen = []
                    let anejamientoAlmacen = []
                    let reposadoAlmacen = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []
                    let opcionesSeleccionadosSeccion6 = []

                    for (const elemento of anexo.dataelementocliente) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 11:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                equipoAlmacen.push(elemento)
                                break
                            case 5:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                granelAlmacen.push(elemento)
                                break
                            case 12:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                maduracionAlmacen.push(elemento)
                                break
                            case 13:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                variablesAlmacen.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            equipoAlmacen,
                            granelAlmacen,
                            maduracionAlmacen,
                            variablesAlmacen,
                            anejamientoAlmacen,
                            reposadoAlmacen
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5,
                            opcionesSeleccionadosSeccion6
                        }
                        anexo.informaciongeneralinstalacioncliente.dataSeccion = dataSeccion
                        anexo.informaciongeneralinstalacioncliente.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    anexo.informaciongeneralinstalacioncliente.tipoinstalacionanejamiento = false
                    anexo.informaciongeneralinstalacioncliente.tipoinstalacionbodega = false
                    anexo.informaciongeneralinstalacioncliente.tipoinstalaciongranel = false
                    anexo.informaciongeneralinstalacioncliente.tipoinstalacionmaduracion = false

                    for (const instalacion of anexo.informaciongeneralinstalacioncliente.instalacionescliente) {
                        switch (instalacion.tipoinstalacion.instalacion) {
                            case 'Producto terminado':
                                anexo.informaciongeneralinstalacioncliente.tipoinstalacionbodega = true
                                break
                            case 'Graneles':
                                anexo.informaciongeneralinstalacioncliente.tipoinstalaciongranel = true
                                break
                            case 'Maduracion en vidrio':
                                anexo.informaciongeneralinstalacioncliente.tipoinstalacionmaduracion = true
                                break
                            default:
                                break
                        }
                    }
                    delete anexo.informaciongeneralinstalacioncliente.instalacionescliente
                    anexo.informaciongeneralinstalacioncliente.tipoInstalacion = 'Unidad Almacén'
                    if (!anexo?.informaciongeneralinstalacioncliente?.isbaja) anexoInstalaciones.push({ data: anexo.informaciongeneralinstalacioncliente })
                }
                countInst++
            }


            let marcas = []
            for (const i in anexosMarcas) {
                let tipomarca = ''
                if (anexosMarcas[i].idtipomarca === 1) tipomarca = '1'
                if (anexosMarcas[i].idtipomarca === 2) tipomarca = '2'
                if (anexosMarcas[i].idtipomarca === 3) tipomarca = '3'
                let titularidad = ''
                if (anexosMarcas[i].idtitularidaddemarca === 1) titularidad = '1'
                if (anexosMarcas[i].idtitularidaddemarca === 2) titularidad = '2'
                if (anexosMarcas[i].idtitularidaddemarca === 3) titularidad = '3'
                if (anexosMarcas[i].idtitularidaddemarca === 4) titularidad = '4'
                if (anexosMarcas[i].idtitularidaddemarca === 5) titularidad = '5'
                if (anexosMarcas[i].idtitularidaddemarca === 6) titularidad = '6'
                if (!anexosMarcas[i].isbaja) marcas.push({
                    id: uuidv4(), marcaregistrada: anexosMarcas[i].registrosi ? 'Si' : anexosMarcas[i].registrono ? 'No' : '', nombremarca: anexosMarcas[i].marca,
                    numeroregistro: anexosMarcas[i].numeroderegistroimpi, titularidad: titularidad,
                    tipomarca: tipomarca,
                    productorautorizado: anexosMarcas[i].productor, maquiladorautorizado: anexosMarcas[i].maquilador,
                    alta: false, baja: false, idmarcascliente: anexosMarcas[i].idmarcascliente,
                    isbaja: anexosMarcas[i].isbaja, iscorregida: false
                })
            }
            let marcasBebidas = []
            for (const i in anexosMarcasBebidas) {
                let tipomarca = ''
                if (anexosMarcasBebidas[i].idtipomarca === 1) tipomarca = '1'
                if (anexosMarcasBebidas[i].idtipomarca === 2) tipomarca = '2'
                if (anexosMarcasBebidas[i].idtipomarca === 3) tipomarca = '3'
                let titularidad = ''
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 1) titularidad = '1'
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 2) titularidad = '2'
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 3) titularidad = '3'
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 4) titularidad = '4'
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 5) titularidad = '5'
                if (anexosMarcasBebidas[i].idtitularidaddemarca === 6) titularidad = '6'
                if (!anexosMarcasBebidas[i].isbaja) marcasBebidas.push({
                    id: uuidv4(), marcaregistrada: anexosMarcasBebidas[i].registrosi ? 'Si' : anexosMarcasBebidas[i].registrono ? 'No' : '', nombremarca: anexosMarcasBebidas[i].marca,
                    numeroregistro: anexosMarcasBebidas[i].numeroderegistroimpi, titularidad: titularidad,
                    tipomarca: tipomarca,
                    productorautorizado: anexosMarcasBebidas[i].productor, maquiladorautorizado: anexosMarcasBebidas[i].maquilador,
                    alta: false, baja: false, idmarcasproductocliente: anexosMarcasBebidas[i].idmarcasproductocliente,
                    isbaja: anexosMarcasBebidas[i].isbaja, iscorregida: false
                })
            }
            let datos = {
                mediosContacto: medios, datosLogin: datosLogin,
                cliente: res?.data?.data?.cliente?.[0], apoderadosLegales: apoderados,
                personasAutorizadas: personasAutorizadas, domiciliosFiscales: domiciliosFiscales,
                tipoInstalaciones: tipoInstalaciones, aliasInstalaciones: aliasInstalaciones,
                responsablesInstalaciones: responsablesInstalaciones, marcas: marcas,
                marcasBebidas: marcasBebidas, numeroInstlaciones: numeroInstlaciones,
                anexosInstalaciones: anexoInstalaciones, predios, viveros,
                fc_36: fc_36
            }
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_36_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const registrarSolicitudFC_36Accion = createAsyncThunk(
    FC_36_SOLICITUD_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const mediosContacto = data.mediosContacto
            const responsablesLegales = data.responsablesLegales
            const personaAutorizada = data.personaAutorizada
            const domiciliosFiscales = data.domiciliosFiscales
            const predios = data.predios
            const viveros = data.viveros
            const instalaciones = data.instalaciones
            const responsablesinstalaciones = data.responsableInst
            const marcas = data.marcas
            const marcasBebidas = data.marcasBebidas

            const agregarFC_36 = host + 'FC_36/agregarNuevoFC_36Solicitud'
            const urlMediosContacto = host + 'FC_36/agregarFC_36MediosContacto'
            const urlApoderados = host + 'FC_36/agregarFC_36RepresentanteLegal'
            const urlPersonas = host + 'FC_36/agregarFC_36PersonasAutorizadas'
            const urlDomicilio = host + 'FC_36/agregarFC_36DomicilioFiscal'
            const urlViveros = host + 'FC_36/agregarFC_36Viveros'
            const urlPredios = host + 'FC_36/agregarFC_36Predios'
            const urlAnexo = host + 'FC_36/agregarFC_36Anexo'
            const urlInformacionGeneral = host + 'FC_36/agregarFC_36InformacionGeneral'
            const urlInstalacion = host + 'FC_36/agregarFC_36Instalacion'
            const urlResponsable = host + 'FC_36/agregarResponsableInstalaciones'
            const urlDataElemento = host + 'FC_36/agregarDataElemento'
            const urlDataResponsables = host + 'FC_36/agregarActualizacionResponsableInstalaciones'
            const urlMarcas = host + 'FC_36/agregarMarcas'
            const urlMarcaBebida = host + 'FC_36/agregarMarcasProducto'


            const res = await axios.post(agregarFC_36, solicitud)

            let idfc36_solicitudactualizacion = res.data.data.idfc36_solicitudactualizacion
            //if (solicitud.data.actualizarmedioscontacto) {
            for (const i in mediosContacto) {
                let data = {
                    telefono: mediosContacto[i].telefono, correoelectronico: mediosContacto[i].correoelectronico,
                    alta: mediosContacto[i].alta, baja: mediosContacto[i].baja, relacioncontacto: Number(mediosContacto[i].idmediosdecontacto),
                    idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: mediosContacto[i].isbaja
                }
                await axios.post(urlMediosContacto, { data: data })
            }
            //}
            //if (solicitud.data.cambioresponsable) {
            for (const i in responsablesLegales) {
                let data = {
                    representantelegal: responsablesLegales[i].representantelegal,
                    telefono: responsablesLegales[i].telefono, correoelectronico: responsablesLegales[i].correoelectronico,
                    alta: responsablesLegales[i].alta, baja: responsablesLegales[i].baja,
                    relacioncontacto: Number(responsablesLegales[i].idapoderadoslegales), principal: responsablesLegales[i].principal,
                    idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: responsablesLegales[i].isbaja
                }
                await axios.post(urlApoderados, { data: data })
            }
            //}
            if (solicitud.data.cambiorepresentante) {
                for (const i in personaAutorizada) {
                    let data = {
                        personaautoriazadaparatramites: personaAutorizada[i].personaautoriazadaparatramites,
                        telefono: personaAutorizada[i].telefono, correoelectronico: personaAutorizada[i].correoelectronico,
                        alta: personaAutorizada[i].alta, baja: personaAutorizada[i].baja,
                        relacioncontacto: Number(personaAutorizada[i].idrepresentantesautorizados),
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: personaAutorizada[i].isbaja
                    }
                    await axios.post(urlPersonas, { data: data })
                }
            }
            //if (solicitud.data.actualizaciondomicilio) {
            for (const i in domiciliosFiscales) {
                let data = {
                    calle: domiciliosFiscales[i].calle, numerointerior: domiciliosFiscales[i].numerointerior,
                    numeroexterior: domiciliosFiscales[i].numeroexterior, colonia: domiciliosFiscales[i].colonia,
                    localidad: domiciliosFiscales[i].localidad, municipio: domiciliosFiscales[i].municipio,
                    codigopostal: domiciliosFiscales[i].codigopostal, estado: domiciliosFiscales[i].estado,
                    alta: domiciliosFiscales[i].alta, baja: domiciliosFiscales[i].baja,
                    relacioncontacto: Number(domiciliosFiscales[i].iddomiciliofiscal),
                    domicilioprincipal: domiciliosFiscales[i].domicilioprincipal == true ? true : false,
                    idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: domiciliosFiscales[i].isbaja
                }
                await axios.post(urlDomicilio, { data: data })
            }
            //}
            if (solicitud.data.actualizacioncadena || solicitud.data.actualizacionprediosviveros) {
                for (const i in viveros) {
                    let cultivado = false
                    let semicultivado = false
                    let silvestre = false
                    if (viveros?.[i]?.cultivado == 'Si') cultivado = true
                    if (viveros?.[i]?.semicultivado == 'Si') semicultivado = true
                    if (viveros?.[i]?.silvestre == 'Si') silvestre = true

                    let data = {
                        cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                        nombreparaje: viveros[i].nombreparaje, localidad: viveros[i].localidad,
                        municipio: viveros[i].municipio, distrito: viveros[i].distrito,
                        estado: viveros[i].estado, calle: viveros[i].calle,
                        numeroexterior: viveros[i].numeroexterior, codigopostal: viveros[i].codigopostal,
                        alta: viveros[i].alta, baja: viveros[i].baja, relacioncontacto: viveros[i].idvivero,
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: false
                    }
                    await axios.post(urlViveros, { data: data })
                }
                for (const i in predios) {
                    let cultivado = false
                    let semicultivado = false
                    let silvestre = false
                    if (predios?.[i]?.cultivado == 'Si') cultivado = true
                    if (predios?.[i]?.semicultivado == 'Si') semicultivado = true
                    if (predios?.[i]?.silvestre == 'Si') silvestre = true

                    let data = {
                        cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                        nombreparaje: predios[i].nombreparaje, localidad: predios[i].localidad,
                        municipio: predios[i].municipio, distrito: predios[i].distrito,
                        estado: predios[i].estado, calle: predios[i].calle,
                        alta: predios[i].alta, baja: predios[i].baja, relacioncontacto: predios[i].idpredio,
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: false
                    }
                    await axios.post(urlPredios, { data: data })
                }
            }
            if (solicitud.data.cambioresponsableinst) {
                for (const i in responsablesinstalaciones) {
                    let data = {
                        tipoinstalacion: responsablesinstalaciones[i].tipoinstalacion, alias: responsablesinstalaciones[i].alias,
                        nombreresponsable: responsablesinstalaciones[i].responsableinstalacion,
                        telefono: responsablesinstalaciones[i].telefono, correoelectronico: responsablesinstalaciones[i].correoelectronico,
                        alta: responsablesinstalaciones[i].alta, baja: responsablesinstalaciones[i].baja, relacioncontacto: responsablesinstalaciones[i].idresponsabledeinstalacioncliente,
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: responsablesinstalaciones[i].isbaja,
                        domicilio: responsablesinstalaciones[i].domicilio,
                    }
                    await axios.post(urlDataResponsables, { data: data })
                }
            }
            if (solicitud.data.actualizacioncadena || solicitud.data.actualizarmarcas) {
                for (const i in marcas) {
                    let si = false
                    let no = false
                    if (marcas[i].marcaregistrada === 'Si') si = true
                    else no = true
                    let data = {
                        marca: marcas[i].nombremarca, numeroderegistroimpi: marcas[i].numeroregistro,
                        idtipomarca: Number(marcas[i].tipomarca), idtitularidaddemarca: Number(marcas[i].titularidad),
                        registrosi: si, registrono: no, productor: marcas[i].productorautorizado, maquilador: marcas[i].maquiladorautorizado,
                        isbaja: marcas[i].isbaja, alta: marcas[i].alta, baja: marcas[i].baja, relacioncontacto: marcas[i].idmarcascliente,
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcas[i].iscorregida == true ? true : false
                    }
                    await axios.post(urlMarcas, { data: data })
                }
                for (const i in marcasBebidas) {
                    let si = false
                    let no = false
                    if (marcasBebidas[i].marcaregistrada === 'Si') si = true
                    else no = true
                    let data = {
                        marca: marcasBebidas[i].nombremarca, numeroderegistroimpi: marcasBebidas[i].numeroregistro,
                        idtipomarca: Number(marcasBebidas[i].tipomarca), idtitularidaddemarca: Number(marcasBebidas[i].titularidad),
                        registrosi: si, registrono: no, productor: marcasBebidas[i].productorautorizado, maquilador: marcasBebidas[i].maquiladorautorizado,
                        isbaja: marcasBebidas[i].isbaja, alta: marcasBebidas[i].alta, baja: marcasBebidas[i].baja, relacioncontacto: marcasBebidas[i].idmarcasproductocliente,
                        idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcasBebidas[i].iscorregida == true ? true : false
                    }
                    await axios.post(urlMarcaBebida, { data: data })
                }
            }

            //Instalaciones
            if (solicitud.data.actualizacioncadena || solicitud.data.actualizacioninstalaciones) {
                for (let i in instalaciones) {
                    const { id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID } = instalaciones[i].data
                    for (let x in anexoInstalacionSinID) {
                        if (anexoInstalacionSinID[x] === "") {
                            anexoInstalacionSinID[x] = null
                        }
                    }
                    if (tipoInstalacion === 'Unidad Producción') {
                        const { idfc36_solicitudactualizacion, isbaja, baja, alta, isedicion, ...unidad } = anexoInstalacionSinID
                        delete unidad.idcliente
                        delete unidad.idanexocliente
                        delete unidad.idiformaciongeneralcliente
                        delete unidad.idfc_36anexo
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                        let dataInstalacion = {
                            idfc_36informaciongeneral: idfc_36informaciongeneral,
                            idtipoinstalacion: 1
                        }
                        await axios.post(urlInstalacion, { data: dataInstalacion })

                        const data = {
                            idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                            idtipoanexo: 1,
                            idfc_36informaciongeneral: idfc_36informaciongeneral,
                            isbaja: isbaja, alta: alta, baja: baja, isedicion: isedicion
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo

                        for (const responsable of responsables) {
                            const { id, estado, ...responsableSinID } = responsable
                            delete responsableSinID.idresponsabledeinstalacioncliente
                            delete responsableSinID.idiformaciongeneralcliente
                            delete responsableSinID.isbaja
                            delete responsableSinID.idfc_36informaciongeneral
                            responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                            if (responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data: responsableSinID })
                        }

                        for (const l in dataSeccion?.coccionProduccion) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.coccionProduccion?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.moliendaProduccion) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.moliendaProduccion?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.fermentacionProduccion) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.fermentacionProduccion?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.destilacionProduccion) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.destilacionProduccion?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if (tipoInstalacion === 'Unidad Envasado') {
                        const { idfc36_solicitudactualizacion, isbaja, baja, alta, isedicion, ...unidad } = anexoInstalacionSinID
                        delete unidad.idcliente
                        delete unidad.idanexocliente
                        delete unidad.idiformaciongeneralcliente
                        delete unidad.idfc_36anexo
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                        let dataInstalacion = {
                            idfc_36informaciongeneral: idfc_36informaciongeneral,
                            idtipoinstalacion: 2,
                        }
                        await axios.post(urlInstalacion, { data: dataInstalacion })

                        const data = {
                            idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                            idtipoanexo: 2,
                            idfc_36informaciongeneral: idfc_36informaciongeneral,
                            isbaja: isbaja, alta: alta, baja: baja, isedicion: isedicion
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo

                        for (const responsable of responsables) {
                            const { id, estado, ...responsableSinID } = responsable
                            responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                            delete responsableSinID.idresponsabledeinstalacioncliente
                            delete responsableSinID.idiformaciongeneralcliente
                            delete responsableSinID.isbaja
                            //delete responsableSinID.idfc_36informaciongeneral
                            if (responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data: responsableSinID })
                        }


                        for (const l in dataSeccion?.seccion1) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.seccion1?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.seccion2) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.seccion2?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.seccion3) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.seccion3?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.seccion4) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.seccion4?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const l in dataSeccion?.seccion5) {
                            const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.seccion5?.[l]
                            dataElemento.idfc_36anexo = idfc_36anexo
                            delete dataElemento.iddataelementocliente
                            delete dataElemento.idanexocliente
                            if (dataElemento.cantidad === '') dataElemento.cantidad = null
                            if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if (tipoInstalacion === 'Unidad Almacén') {
                        const { tipoinstalacionanejamiento, tipoinstalacionbodega,
                            tipoinstalaciongranel, tipoinstalacionmaduracion,
                            tipoinstalacionreposado, idfc36_solicitudactualizacion,
                            isbaja, baja, alta, isedicion, ...unidad } = anexoInstalacionSinID
                        delete unidad.idcliente
                        delete unidad.idanexocliente
                        delete unidad.idiformaciongeneralcliente
                        delete unidad.idfc_36anexo
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                        if (tipoinstalacionbodega) {
                            const data = {
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                idtipoinstalacion: 3,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if (tipoinstalaciongranel) {
                            const data = {
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                idtipoinstalacion: 4,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if (tipoinstalacionmaduracion) {
                            const data = {
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                idtipoinstalacion: 5,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        for (const responsable of responsables) {
                            const { id, estado, ...responsableSinID } = responsable
                            responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                            delete responsableSinID.idresponsabledeinstalacioncliente
                            delete responsableSinID.idiformaciongeneralcliente
                            delete responsableSinID.isbaja
                            //delete responsableSinID.idfc_36informaciongeneral
                            if (responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data: responsableSinID })
                        }
                        const data = {
                            idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                            idtipoanexo: 3,
                            idfc_36informaciongeneral: idfc_36informaciongeneral,
                            isbaja: isbaja, alta: alta, baja: baja, isedicion: isedicion
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo

                        if (tipoinstalacionbodega) {
                            for (const l in dataSeccion?.equipoAlmacen) {
                                const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.equipoAlmacen?.[l]
                                dataElemento.idfc_36anexo = idfc_36anexo
                                delete dataElemento.iddataelementocliente
                                delete dataElemento.idanexocliente
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if (tipoinstalaciongranel) {
                            for (const l in dataSeccion?.granelAlmacen) {
                                const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.granelAlmacen?.[l]
                                dataElemento.idfc_36anexo = idfc_36anexo
                                delete dataElemento.iddataelementocliente
                                delete dataElemento.idanexocliente
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if (tipoinstalacionmaduracion) {
                            for (const l in dataSeccion?.maduracionAlmacen) {
                                const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.maduracionAlmacen?.[l]
                                dataElemento.idfc_36anexo = idfc_36anexo
                                delete dataElemento.iddataelementocliente
                                delete dataElemento.idanexocliente
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if (tipoinstalacionmaduracion) {
                            for (const l in dataSeccion?.variablesAlmacen) {
                                const { id, opcion, capacidad, ...dataElemento } = dataSeccion?.variablesAlmacen?.[l]
                                dataElemento.idfc_36anexo = idfc_36anexo
                                delete dataElemento.iddataelementocliente
                                delete dataElemento.idanexocliente
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                    }
                }
            }
            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_36SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_36_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_36/eliminarUnaSolicitudFC_36/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_36SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_36_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_36/obtenerFormatoFC36_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            const documentosGenerales = []
            for (const i in res.data.data.fc_36archivogeneral) {
                const { ...anexo } = res.data.data.fc_36archivogeneral[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_36archivogeneral,
                    idAnexoFK: res.data.data.idfc36_solicitudactualizacion,
                    estatus: true,
                }
                documentosGenerales.push(data)
            }

            if (res.data.data.fechadenacimiento) {
                let fecha = res.data.data.fechadenacimiento
                res.data.data.fechadenacimiento = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            let mediosContacto = []
            for (const i in res.data.data.fc_36_anexomediosdecontacto) {
                res.data.data.fc_36_anexomediosdecontacto[i].id = uuidv4()
                mediosContacto.push(res.data.data.fc_36_anexomediosdecontacto[i])
            }
            let apoderadosLegales = []
            const documentosApoderados = []
            for (const i in res.data.data.fc_36_anexoapoderadoslegales) {
                res.data.data.fc_36_anexoapoderadoslegales[i].id = uuidv4()
                apoderadosLegales.push(res.data.data.fc_36_anexoapoderadoslegales[i])
                for (const j in res.data.data.fc_36_anexoapoderadoslegales[i].fc_36archivoresponsablelegal) {
                    const { ...anexo } = res.data.data.fc_36_anexoapoderadoslegales[i].fc_36archivoresponsablelegal[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivoresponsablelegal,
                        idAnexoFK: res.data.data.fc_36_anexoapoderadoslegales[i].idfc36_anexoapoderadoslegales,
                        estatus: true,
                    }
                    documentosApoderados.push(data)
                }
            }
            let personasAutorizadas = []
            const documentosPersonas = []
            for (const i in res.data.data.fc_36_anexopersonasautorizadas) {
                res.data.data.fc_36_anexopersonasautorizadas[i].id = uuidv4()

                personasAutorizadas.push(res.data.data.fc_36_anexopersonasautorizadas[i])
                for (const j in res.data.data.fc_36_anexopersonasautorizadas[i].fc_36archivopersonasautorizadas) {
                    const { ...anexo } = res.data.data.fc_36_anexopersonasautorizadas[i].fc_36archivopersonasautorizadas[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivopersonasautorizadas,
                        idAnexoFK: res.data.data.fc_36_anexopersonasautorizadas[i].idfc36_anexopersonasautorizadas,
                        estatus: true,
                    }
                    documentosPersonas.push(data)
                }
            }
            let domicilioFiscal = []
            const documentosDomicilio = []
            for (const i in res.data.data.fc_36_anexodomiciliosfiscales) {
                res.data.data.fc_36_anexodomiciliosfiscales[i].id = uuidv4()
                const { ...anexo } = res.data.data.fc_36_anexodomiciliosfiscales[i]
                res.data.data.fc_36_anexodomiciliosfiscales[i].domicilio = anexo.calle + ', ' + anexo.numerointerior + ', ' + anexo.numeroexterior + ', ' +
                    anexo.colonia + ', ' + anexo.localidad + ', ' + anexo.municipio + ', ' + anexo.estado + ', ' + anexo.codigopostal
                domicilioFiscal.push(res.data.data.fc_36_anexodomiciliosfiscales[i])
                for (const j in res.data.data.fc_36_anexodomiciliosfiscales[i].fc_36archivodomiciliosficales) {
                    const { ...anexo } = res.data.data.fc_36_anexodomiciliosfiscales[i].fc_36archivodomiciliosficales[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivodomiciliosfiscales,
                        idAnexoFK: res.data.data.fc_36_anexodomiciliosfiscales[i].idfc36_anexodomiciliosfiscales,
                        estatus: true,
                    }
                    documentosDomicilio.push(data)
                }
            }
            let viveros = []
            const documentosvivieros = []
            const opcionesFileVivero = []
            for (const i in res.data.data.fc_36_anexoviveros) {
                res.data.data.fc_36_anexoviveros[i].id = uuidv4()
                const { ...anexo } = res.data.data.fc_36_anexoviveros[i]
                res.data.data.fc_36_anexoviveros[i].domicilio = anexo.numeroexterior + ',' + anexo.calle + ',' + anexo.localidad + ',' + anexo.municipio + ',' + anexo.distrito + ',' + anexo.estado + ',' + anexo.codigopostal
                if (res.data.data.fc_36_anexoviveros[i].cultivado) res.data.data.fc_36_anexoviveros[i].cultivado = 'Si'
                else res.data.data.fc_36_anexoviveros[i].cultivado = 'No'
                if (res.data.data.fc_36_anexoviveros[i].semicultivado) res.data.data.fc_36_anexoviveros[i].semicultivado = 'Si'
                else res.data.data.fc_36_anexoviveros[i].semicultivado = 'No'
                if (res.data.data.fc_36_anexoviveros[i].silvestre) res.data.data.fc_36_anexoviveros[i].silvestre = 'Si'
                else res.data.data.fc_36_anexoviveros[i].silvestre = 'No'

                viveros.push(res.data.data.fc_36_anexoviveros[i])
                for (const j in res.data.data.fc_36_anexoviveros[i].fc_36archivovivero) {
                    const { ...anexo } = res.data.data.fc_36_anexoviveros[i].fc_36archivovivero[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivovivero,
                        idAnexoFK: res.data.data.fc_36_anexoviveros[i].idfc_36_anexoviveros,
                        estatus: true,
                    }
                    documentosvivieros.push(data)
                    if ((anexo.nameid).includes('COPIAESC')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'copiaescritura' })
                    } else if ((anexo.nameid).includes('CONSPOS')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'constanciaposesion' })
                    } else if ((anexo.nameid).includes('CONARREN')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratoarrendamiento' })
                    } else if ((anexo.nameid).includes('CONCOMPR')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocompraventa' })
                    } else if ((anexo.nameid).includes('CONCOMODA')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocomodato' })
                    }
                }
            }
            let predios = []
            const documentosPredios = []
            const opcionesFilePredio = []
            for (const i in res.data.data.fc_36_anexopredio) {
                res.data.data.fc_36_anexopredio[i].id = uuidv4()
                const { ...anexo } = res.data.data.fc_36_anexopredio[i]
                res.data.data.fc_36_anexopredio[i].domicilio = anexo.localidad + ',' + anexo.municipio + ',' + anexo.distrito + ',' + anexo.estado
                if (res.data.data.fc_36_anexopredio[i].cultivado) res.data.data.fc_36_anexopredio[i].cultivado = 'Si'
                else res.data.data.fc_36_anexopredio[i].cultivado = 'No'
                if (res.data.data.fc_36_anexopredio[i].semicultivado) res.data.data.fc_36_anexopredio[i].semicultivado = 'Si'
                else res.data.data.fc_36_anexopredio[i].semicultivado = 'No'
                if (res.data.data.fc_36_anexopredio[i].silvestre) res.data.data.fc_36_anexopredio[i].silvestre = 'Si'
                else res.data.data.fc_36_anexopredio[i].silvestre = 'No'
                predios.push(res.data.data.fc_36_anexopredio[i])
                for (const j in res.data.data.fc_36_anexopredio[i].fc_36archivopredio) {
                    const { ...anexo } = res.data.data.fc_36_anexopredio[i].fc_36archivopredio[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivopredio,
                        idAnexoFK: res.data.data.fc_36_anexopredio[i].idfc36_anexopredio,
                        estatus: true,
                    }
                    documentosPredios.push(data)
                    if ((anexo.nameid).includes('COPIAESC')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'copiaescritura' })
                    } else if ((anexo.nameid).includes('CONSPOS')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'constanciaposesion' })
                    } else if ((anexo.nameid).includes('CONARREN')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratoarrendamiento' })
                    } else if ((anexo.nameid).includes('CONCOMPR')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocompraventa' })
                    } else if ((anexo.nameid).includes('CONCOMODA')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocomodato' })
                    }
                }
            }
            let responsableInst = []
            const documentosResponsableInst = []
            for (const i in res.data.data.fc_36_actualizacionresponsableinstalaciones) {
                res.data.data.fc_36_actualizacionresponsableinstalaciones[i].id = uuidv4()
                const { ...anexo } = res.data.data.fc_36_actualizacionresponsableinstalaciones[i]
                res.data.data.fc_36_actualizacionresponsableinstalaciones[i].responsableinstalacion = res.data.data.fc_36_actualizacionresponsableinstalaciones[i].nombreresponsable
                responsableInst.push(res.data.data.fc_36_actualizacionresponsableinstalaciones[i])
                for (const j in res.data.data.fc_36_actualizacionresponsableinstalaciones[i].fc_36archivoactualizacionresponsables) {
                    const { ...anexo } = res.data.data.fc_36_actualizacionresponsableinstalaciones[i].fc_36archivoactualizacionresponsables[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_36archivoresponsables,
                        idAnexoFK: res.data.data.fc_36_actualizacionresponsableinstalaciones[i].idfc_36_actulizarresponsableinstalaciones,
                        estatus: true,
                    }
                    documentosResponsableInst.push(data)
                }
            }
            let anexoMarcas = []
            let documentacionMarca = []
            for (let i in res.data.data.fc_36_anexomarcas) {
                let marcaregistrada = ''
                if (res.data.data.fc_36_anexomarcas[i].registrono) marcaregistrada = 'No'
                if (res.data.data.fc_36_anexomarcas[i].registrosi) marcaregistrada = 'Si'
                res.data.data.fc_36_anexomarcas[i]['id'] = uuidv4()
                res.data.data.fc_36_anexomarcas[i].tipomarca = res.data.data.fc_36_anexomarcas[i].idtipomarca
                res.data.data.fc_36_anexomarcas[i].titularidad = res.data.data.fc_36_anexomarcas[i].idtitularidaddemarca
                res.data.data.fc_36_anexomarcas[i].nombremarca = res.data.data.fc_36_anexomarcas[i].marca
                res.data.data.fc_36_anexomarcas[i].productorautorizado = res.data.data.fc_36_anexomarcas[i].productor
                res.data.data.fc_36_anexomarcas[i].maquiladorautorizado = res.data.data.fc_36_anexomarcas[i].maquilador
                res.data.data.fc_36_anexomarcas[i].numeroregistro = res.data.data.fc_36_anexomarcas[i].numeroderegistroimpi
                res.data.data.fc_36_anexomarcas[i].si = res.data.data.fc_36_anexomarcas[i].registrosi
                res.data.data.fc_36_anexomarcas[i].no = res.data.data.fc_36_anexomarcas[i].registrono
                res.data.data.fc_36_anexomarcas[i].marcaregistrada = marcaregistrada

                for (const anexo of res.data.data.fc_36_anexomarcas[i]['fc_36_archivosmarcas']) {
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idarchivosmarca,
                        idAnexoFK: res.data.data.fc_36_anexomarcas[i].idfc36_anexomarcas,
                        estatus: true,
                    }
                    documentacionMarca.push(data)
                }
            }
            anexoMarcas = res.data.data.fc_36_anexomarcas

            let anexomarcasProductoConMezcal = []
            let documentacionMarcaProducto = []
            for (let i in res.data.data.fc_36_anexomarcasproductoconmezcal) {
                let marcaregistrada = ''
                if (res.data.data.fc_36_anexomarcasproductoconmezcal[i].registrono) marcaregistrada = 'No'
                if (res.data.data.fc_36_anexomarcasproductoconmezcal[i].registrosi) marcaregistrada = 'Si'
                res.data.data.fc_36_anexomarcasproductoconmezcal[i]['id'] = uuidv4()
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].tipomarca = res.data.data.fc_36_anexomarcasproductoconmezcal[i].idtipomarca
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].titularidad = res.data.data.fc_36_anexomarcasproductoconmezcal[i].idtitularidaddemarca
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].nombremarca = res.data.data.fc_36_anexomarcasproductoconmezcal[i].marca
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].productorautorizado = res.data.data.fc_36_anexomarcasproductoconmezcal[i].productor
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].maquiladorautorizado = res.data.data.fc_36_anexomarcasproductoconmezcal[i].maquilador
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].numeroregistro = res.data.data.fc_36_anexomarcasproductoconmezcal[i].numeroderegistroimpi
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].si = res.data.data.fc_36_anexomarcasproductoconmezcal[i].registrosi
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].no = res.data.data.fc_36_anexomarcasproductoconmezcal[i].registrono
                res.data.data.fc_36_anexomarcasproductoconmezcal[i].marcaregistrada = marcaregistrada

                for (const anexo of res.data.data.fc_36_anexomarcasproductoconmezcal[i]['fc_36_archivosmarcasproducto']) {
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idarchivosmarcaproducto,
                        idAnexoFK: res.data.data.fc_36_anexomarcasproductoconmezcal[i].idfc36_anexomarcasproductoconmezcal,
                        estatus: true,
                    }
                    documentacionMarcaProducto.push(data)
                }
            }
            anexomarcasProductoConMezcal = res.data.data.fc_36_anexomarcasproductoconmezcal

            let anexoInstalaciones = []
            let documentacionInstalaciones = []
            let maxNumeroDeInstlacion = 0
            let documentacionResponsables = []
            let countInst = 0
            const opcionesFileInstalacion = []
            for (const anexo of res.data.data.fc_36anexo) {
                anexo.fc_36informaciongeneral.id = uuidv4()
                anexo.fc_36informaciongeneral.idfc36_solicitudactualizacion = anexo.idfc36_solicitudactualizacion
                anexo.fc_36informaciongeneral.idfc_36anexo = anexo.idfc_36anexo
                let domicilio = ''
                if (anexo.fc_36informaciongeneral.calle !== null) {
                    if (anexo.fc_36informaciongeneral.calle === 'Otro') {
                        domicilio += anexo.fc_36informaciongeneral.otracalle + ', '
                    }
                }
                if (anexo.fc_36informaciongeneral.colonia !== null) {
                    domicilio += anexo.fc_36informaciongeneral.colonia + ', '
                }
                if (anexo.fc_36informaciongeneral.localidad !== null) {
                    domicilio += anexo.fc_36informaciongeneral.localidad + ', '
                }
                if (anexo.fc_36informaciongeneral.municipio !== null) {
                    domicilio += anexo.fc_36informaciongeneral.municipio + ', '
                }
                if (anexo.fc_36informaciongeneral.estado !== null) {
                    domicilio += anexo.fc_36informaciongeneral.estado + ', '
                }
                if (anexo.fc_36informaciongeneral.codigopostal !== null) {
                    domicilio += anexo.fc_36informaciongeneral.codigopostal + ', '
                }
                if (domicilio === '') domicilio = 'No se asignó un domicilio'
                anexo.fc_36informaciongeneral.domicilio = domicilio

                for (const anexoInstalacion of anexo.fc_36_archivosinstalaciones) {
                    const data = {
                        id: anexoInstalacion.nameid,
                        file: { name: await getNameFile(anexoInstalacion.ruta) },
                        idAnexo: anexoInstalacion.idarchivosinstalacion,
                        idAnexoFK: anexo.idfc_36anexo,
                        estatus: true,
                    }
                    documentacionInstalaciones.push(data)
                    if ((data.id).includes('TITULOINS')) {
                        opcionesFileInstalacion.push({ id: 'INST' + data.idAnexoFK, opcionFile: 'copiatitulopropiedad' })
                    } else if ((data.id).includes('CAINSP')) {
                        opcionesFileInstalacion.push({ id: 'INST' + data.idAnexoFK, opcionFile: 'contratoarrendamientopublico' })
                    } else if ((data.id).includes('CAINS')) {
                        opcionesFileInstalacion.push({ id: 'INST' + data.idAnexoFK, opcionFile: 'contratoarrendamientoprivado' })
                    } else if ((data.id).includes('CCINSP')) {
                        opcionesFileInstalacion.push({ id: 'INST' + data.idAnexoFK, opcionFile: 'contratocomodatopublico' })
                    } else if ((data.id).includes('CCINS')) {
                        opcionesFileInstalacion.push({ id: 'INST' + data.idAnexoFK, opcionFile: 'contratocomodatoprivado' })
                    }
                }

                for (let i in anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion) {
                    anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion[i]['id'] = uuidv4()
                    let estado = await comprobarEmail(anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion[i].correoelectronico)
                    anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion[i]['estado'] = estado
                    for (const anexoRes of anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion[i]['fc_36_archivosresposansables']) {
                        const data = {
                            id: anexoRes.nameid,
                            file: { name: await getNameFile(anexoRes.ruta) },
                            idAnexo: anexoRes.idarchivosresponsables,
                            idAnexoFK: anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion[i].idfc_36responsabledeinstalacion,
                            estatus: true,
                        }
                        documentacionResponsables.push(data)
                    }
                }

                const responsables = anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion
                delete anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion
                anexo.fc_36informaciongeneral.responsables = responsables

                if (anexo.fc_36informaciongeneral.instalacionnumero > maxNumeroDeInstlacion) maxNumeroDeInstlacion = anexo.fc_36informaciongeneral.instalacionnumero

                if (anexo.idtipoanexo === 1) {
                    let coccionProduccion = []
                    let moliendaProduccion = []
                    let fermentacionProduccion = []
                    let destilacionProduccion = []
                    let granelProduccion = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.fc_36_dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 1:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                coccionProduccion.push(elemento)
                                break
                            case 2:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                moliendaProduccion.push(elemento)
                                break
                            case 3:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                fermentacionProduccion.push(elemento)
                                break
                            case 4:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                destilacionProduccion.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            coccionProduccion,
                            moliendaProduccion,
                            fermentacionProduccion,
                            destilacionProduccion,
                            granelProduccion
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.fc_36informaciongeneral.dataSeccion = dataSeccion
                        anexo.fc_36informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.fc_36informaciongeneral.fc_36instalaciones
                    anexo.fc_36informaciongeneral.baja = anexo.baja
                    anexo.fc_36informaciongeneral.alta = anexo.alta
                    anexo.fc_36informaciongeneral.isbaja = anexo.isbaja
                    anexo.fc_36informaciongeneral.isedicion = anexo.isedicion
                    anexo.fc_36informaciongeneral.tipoInstalacion = 'Unidad Producción'
                    anexoInstalaciones.push({ data: anexo.fc_36informaciongeneral })
                }
                if (anexo.idtipoanexo === 2) {
                    let seccion1 = []
                    let seccion2 = []
                    let seccion3 = []
                    let seccion4 = []
                    let seccion5 = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.fc_36_dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 6:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion1.push(elemento)
                                break
                            case 7:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion2.push(elemento)
                                break
                            case 8:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion3.push(elemento)
                                break
                            case 9:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion4.push(elemento)
                                break
                            case 10:
                                opcionesSeleccionadosSeccion5.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                seccion5.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = { seccion1, seccion2, seccion3, seccion4, seccion5 }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.fc_36informaciongeneral.dataSeccion = dataSeccion
                        anexo.fc_36informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.fc_36informaciongeneral.fc_36instalaciones
                    anexo.fc_36informaciongeneral.baja = anexo.baja
                    anexo.fc_36informaciongeneral.alta = anexo.alta
                    anexo.fc_36informaciongeneral.isbaja = anexo.isbaja
                    anexo.fc_36informaciongeneral.isedicion = anexo.isedicion
                    anexo.fc_36informaciongeneral.tipoInstalacion = 'Unidad Envasado'
                    anexoInstalaciones.push({ data: anexo.fc_36informaciongeneral })
                }
                if (anexo.idtipoanexo === 3) {
                    let equipoAlmacen = []
                    let maduracionAlmacen = []
                    let variablesAlmacen = []
                    let granelAlmacen = []
                    let anejamientoAlmacen = []
                    let reposadoAlmacen = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []
                    let opcionesSeleccionadosSeccion6 = []

                    for (const elemento of anexo.fc_36_dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch (elemento.idseccion) {
                            case 11:
                                opcionesSeleccionadosSeccion1.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                equipoAlmacen.push(elemento)
                                break
                            case 5:
                                opcionesSeleccionadosSeccion4.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                granelAlmacen.push(elemento)
                                break
                            case 12:
                                opcionesSeleccionadosSeccion2.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                maduracionAlmacen.push(elemento)
                                break
                            case 13:
                                opcionesSeleccionadosSeccion3.push({ nombre: elemento.elemento.nombreelemento })
                                delete elemento.elemento
                                variablesAlmacen.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            equipoAlmacen,
                            granelAlmacen,
                            maduracionAlmacen,
                            variablesAlmacen,
                            anejamientoAlmacen,
                            reposadoAlmacen
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5,
                            opcionesSeleccionadosSeccion6
                        }
                        anexo.fc_36informaciongeneral.dataSeccion = dataSeccion
                        anexo.fc_36informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    anexo.fc_36informaciongeneral.tipoinstalacionanejamiento = false
                    anexo.fc_36informaciongeneral.tipoinstalacionbodega = false
                    anexo.fc_36informaciongeneral.tipoinstalaciongranel = false
                    anexo.fc_36informaciongeneral.tipoinstalacionmaduracion = false

                    for (const instalacion of anexo.fc_36informaciongeneral.fc_36instalaciones) {
                        switch (instalacion.tipoinstalacion.instalacion) {
                            case 'Producto terminado':
                                anexo.fc_36informaciongeneral.tipoinstalacionbodega = true
                                break
                            case 'Graneles':
                                anexo.fc_36informaciongeneral.tipoinstalaciongranel = true
                                break
                            case 'Maduracion en vidrio':
                                anexo.fc_36informaciongeneral.tipoinstalacionmaduracion = true
                                break
                            default:
                                break
                        }
                    }
                    delete anexo.fc_36informaciongeneral.fc_36instalaciones
                    anexo.fc_36informaciongeneral.baja = anexo.baja
                    anexo.fc_36informaciongeneral.alta = anexo.alta
                    anexo.fc_36informaciongeneral.isbaja = anexo.isbaja
                    anexo.fc_36informaciongeneral.isedicion = anexo.isedicion
                    anexo.fc_36informaciongeneral.tipoInstalacion = 'Unidad Almacén'
                    anexoInstalaciones.push({ data: anexo.fc_36informaciongeneral })
                }
                countInst++
            }
            let data = {
                data: res.data.data,
                mediosContacto: mediosContacto,
                apoderadosLegales: apoderadosLegales, documentosApoderados: documentosApoderados,
                personasAutorizadas: personasAutorizadas, documentosPersonas: documentosPersonas,
                domicilioFiscal: domicilioFiscal, documentosDomicilio: documentosDomicilio, predios: predios, documentosPredios: documentosPredios,
                viveros: viveros, documentosvivieros: documentosvivieros, opcionesFilePredio: opcionesFilePredio, opcionesFileVivero: opcionesFileVivero,
                maxNumeroDeInstlacion: maxNumeroDeInstlacion, anexoInstalaciones: anexoInstalaciones, documentacionInstalaciones: documentacionInstalaciones,
                opcionesFileInstalacion: opcionesFileInstalacion, documentacionResponsables: documentacionResponsables,
                responsableInst: responsableInst, documentosResponsableInst: documentosResponsableInst,
                anexoMarcas: anexoMarcas, anexomarcasProductoConMezcal: anexomarcasProductoConMezcal,
                documentacionMarcaProducto: documentacionMarcaProducto, documentacionMarca: documentacionMarca,
                documentosGenerales: documentosGenerales

            }
            return data
        } catch (error) {
            console.log(error);
        }
    }
)
const comprobarEmail = async (correo) => {
    const patron = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
    const emailsAceptados = ['@gmail', '@yahoo', '@outlook', '@hotmail'];
    const extensionesAceptadas = ['.mx', '.com', '.es'];
    let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let isEmailAceptadoFlag = false;
    let isExtensionAceptadaFlag = false;

    if (correo.match(emailRegex)) {
        isEmailAceptadoFlag = true;
        isExtensionAceptadaFlag = true;

        if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
            return true
        } else {
            return false
        }
    }
    else {
        return false
    }

}
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const eliminarFC_36AnexoMedioContactoBD = createAsyncThunk(
    ELIMINAR_FC_46_ANEXO_MEDIO_CONTACTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarUnFC_36MedioContacto/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_36AnexoRepresentanteLegalBD = createAsyncThunk(
    ELIMINAR_FC_46_ANEXO_REPRESENTANTE_LEGAL_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarUnFC_36RepresentanteLegal/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_36AnexoPersonaAutorizadaBD = createAsyncThunk(
    ELIMINAR_FC_46_ANEXO_PERSONA_AUTORIZADA_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarUnFC_36PersonasAutorizadas/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_36Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_36_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const mediosContacto = data.mediosContacto
            const responsablesLegales = data.responsablesLegales
            const personaAutorizada = data.personaAutorizada
            const domiciliosFiscales = data.domiciliosFiscales
            const instalaciones = data.instalaciones
            const responsablesinstalaciones = data.responsableInst
            const marcas = data.marcas
            const marcasBebidas = data.marcasBebidas
            const predios = data.predios
            const viveros = data.viveros

            const actualizarFC_36 = host + `FC_36/actualizarSolicitudFC_36`
            const urlAgregarMediosContacto = host + 'FC_36/agregarFC_36MediosContacto'
            const urlActualizarMediosContacto = host + 'FC_36/actualizarFC_36MedioContacto'
            const urlAgregarRepresentanteLegal = host + 'FC_36/agregarFC_36RepresentanteLegal'
            const urlActualizarRepresentanteLegal = host + 'FC_36/actualizarFC_36RepresentanteLegal'
            const urlAgregarPersonaAutorizada = host + 'FC_36/agregarFC_36PersonasAutorizadas'
            const urlActualizarPersonaAutorizada = host + 'FC_36/actualizarFC_36PersonasAutorizadas'
            const urlAgregarDomicilioFiscal = host + 'FC_36/agregarFC_36DomicilioFiscal'
            const urlActualizarDomicilioFiscal = host + 'FC_36/actualizarFC_36DomicilioFiscal'
            const urlAgregarResponsableActualizacion = host + 'FC_36/agregarActualizacionResponsableInstalaciones'
            const urlActualizarResponsableActualizacion = host + 'FC_36/actualizarActualizacionResponsableInstalaciones'
            const urlActualizarMarca = host + 'FC_36/actualizarMarca'
            const urlAgregarMarca = host + 'FC_36/agregarMarcas'
            const urlActualizarMarcaBebida = host + 'FC_36/actualizarMarcaProducto'
            const urlAgregarMarcaBebida = host + 'FC_36/agregarMarcasProducto'

            const urlViveros = host + 'FC_36/agregarFC_36Viveros'
            const urlPredios = host + 'FC_36/agregarFC_36Predios'
            const urlActualizarViveros = host + 'FC_36/actualizarFC_36Viveros'
            const urlActualizarPredios = host + 'FC_36/actualizarFC_36Predios'

            const urlAnexo = host + 'FC_36/agregarFC_36Anexo'
            const urlActualizarAnexo = host + 'FC_36/actualizarAnexo'
            const urlInformacionGeneral = host + 'FC_36/agregarFC_36InformacionGeneral'
            const urlActualizarInformacionGeneral = host + 'FC_36/actualizarInformacionGeneral'
            const urlInstalacion = host + 'FC_36/agregarFC_36Instalacion'
            const urlActualizarInstalacion = host + 'FC_36/actualizarInstalacion'
            const urlDataElemento = host + 'FC_36/agregarDataElemento'
            const urlActualizarDataElemento = host + 'FC_36/actualizarDataElemento'
            const urlResponsable = host + 'FC_36/agregarResponsableInstalaciones'
            const urlActualizarResponsable = host + 'FC_36/actualizarResponsableInstalaciones'

            const res = await axios.put(actualizarFC_36, solicitud)
            let idfc36_solicitudactualizacion = res.data.data.idfc36_solicitudactualizacion
            if (solicitud.data?.actualizarmedioscontacto) {
                for (let i in mediosContacto) {
                    const { id, ...anexo } = mediosContacto[i]
                    if (anexo.idfc36_anexomediodecontacto) {
                        const result = await axios.put(urlActualizarMediosContacto, { data: anexo })
                    } else {
                        let data = {
                            telefono: mediosContacto[i].telefono, correoelectronico: mediosContacto[i].correoelectronico,
                            alta: mediosContacto[i].alta, baja: mediosContacto[i].baja, relacioncontacto: Number(mediosContacto[i].idmediosdecontacto),
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: mediosContacto[i].isbaja,
                        }
                        await axios.post(urlAgregarMediosContacto, { data: data })
                    }
                }
            }
            if (solicitud.data?.cambioresponsable) {
                for (let i in responsablesLegales) {
                    const { id, fc_36archivoresponsablelegal, ...anexo } = responsablesLegales[i]
                    if (anexo.idfc36_anexoapoderadoslegales) {
                        const result = await axios.put(urlActualizarRepresentanteLegal, { data: anexo })
                    } else {
                        let data = {
                            representantelegal: responsablesLegales[i].representantelegal,
                            telefono: responsablesLegales[i].telefono, correoelectronico: responsablesLegales[i].correoelectronico,
                            alta: responsablesLegales[i].alta, baja: responsablesLegales[i].baja,
                            relacioncontacto: Number(responsablesLegales[i].idrepresentantesautorizados),
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: responsablesLegales[i].isbaja,
                            principal: responsablesLegales[i].principal,
                        }
                        await axios.post(urlAgregarRepresentanteLegal, { data: data })

                    }
                }
            }
            if (solicitud.data?.cambiorepresentante) {
                for (let i in personaAutorizada) {
                    const { id, fc_36archivopersonasautorizadas, ...anexo } = personaAutorizada[i]
                    if (anexo.idfc36_anexopersonasautorizadas) {
                        const result = await axios.put(urlActualizarPersonaAutorizada, { data: anexo })
                    } else {
                        let data = {
                            personaautoriazadaparatramites: personaAutorizada[i].personaautoriazadaparatramites,
                            telefono: personaAutorizada[i].telefono, correoelectronico: personaAutorizada[i].correoelectronico,
                            alta: personaAutorizada[i].alta, baja: personaAutorizada[i].baja,
                            relacioncontacto: Number(personaAutorizada[i].idrepresentantesautorizados),
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: personaAutorizada[i].isbaja,
                        }
                        await axios.post(urlAgregarPersonaAutorizada, { data: data })
                    }
                }
            }
            if (solicitud.data?.actualizaciondomicilio) {
                for (let i in domiciliosFiscales) {
                    const { id, fc_36archivodomiciliosficales, domicilio, ...anexo } = domiciliosFiscales[i]
                    if (anexo.idfc36_anexodomiciliosfiscales) {
                        let doact = await axios.put(urlActualizarDomicilioFiscal, { data: anexo })
                    } else {
                        let data = {
                            calle: domiciliosFiscales[i].calle, numerointerior: domiciliosFiscales[i].numerointerior,
                            numeroexterior: domiciliosFiscales[i].numeroexterior, colonia: domiciliosFiscales[i].colonia,
                            localidad: domiciliosFiscales[i].localidad, municipio: domiciliosFiscales[i].municipio,
                            codigopostal: domiciliosFiscales[i].codigopostal, estado: domiciliosFiscales[i].estado,
                            alta: domiciliosFiscales[i].alta, baja: domiciliosFiscales[i].baja,
                            relacioncontacto: Number(domiciliosFiscales[i].iddomiciliofiscal),
                            domicilioprincipal: domiciliosFiscales[i].domicilioprincipal == true ? true : false,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: domiciliosFiscales[i].isbaja
                        }
                        let agrega = await axios.post(urlAgregarDomicilioFiscal, { data: data })
                    }
                }
            }
            if (solicitud.data?.cambioresponsableinst) {
                for (const i in responsablesinstalaciones) {
                    const { id, fc_36archivoactualizacionresponsables, responsableinstalacion, ...anexo } = responsablesinstalaciones[i]
                    if (anexo.idfc_36_actulizarresponsableinstalaciones) {
                        await axios.put(urlActualizarResponsableActualizacion, { data: anexo })
                    } else {
                        let data = {
                            tipoinstalacion: responsablesinstalaciones[i].tipoinstalacion, alias: responsablesinstalaciones[i].alias,
                            nombreresponsable: responsablesinstalaciones[i].responsableinstalacion,
                            telefono: responsablesinstalaciones[i].telefono, correoelectronico: responsablesinstalaciones[i].correoelectronico,
                            alta: responsablesinstalaciones[i].alta, baja: responsablesinstalaciones[i].baja, relacioncontacto: responsablesinstalaciones[i].idresponsabledeinstalacioncliente,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: responsablesinstalaciones[i].isbaja, domicilio: responsablesinstalaciones[i].domicilio
                        }
                        await axios.post(urlAgregarResponsableActualizacion, { data: data })
                    }
                }
            }
            if (solicitud.data?.actualizacioncadena || solicitud.data.actualizarmarcas) {
                for (const i in marcas) {
                    const { id, fc_36_archivosmarcas, marcaregistrada, ...anexo } = marcas[i]
                    if (anexo.idfc36_anexomarcas) {
                        let si = false
                        let no = false
                        if (marcas[i].marcaregistrada === 'Si') si = true
                        else no = true
                        anexo.si = si
                        anexo.no = no
                        let data = {
                            marca: marcas[i].nombremarca, numeroderegistroimpi: marcas[i].numeroregistro,
                            idtipomarca: Number(marcas[i].tipomarca), idtitularidaddemarca: Number(marcas[i].titularidad),
                            registrosi: si, registrono: no, productor: marcas[i].productorautorizado, maquilador: marcas[i].maquiladorautorizado,
                            isbaja: marcas[i].isbaja, alta: marcas[i].alta, baja: marcas[i].baja, relacioncontacto: marcas[i].idmarcascliente,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcas[i].iscorregida == true ? true : false,
                            idfc36_anexomarcas: anexo.idfc36_anexomarcas
                        }
                        await axios.put(urlActualizarMarca, { data: data })
                    } else {
                        let si = false
                        let no = false
                        if (marcas[i].marcaregistrada === 'Si') si = true
                        else no = true
                        let data = {
                            marca: marcas[i].nombremarca, numeroderegistroimpi: marcas[i].numeroregistro,
                            idtipomarca: Number(marcas[i].tipomarca), idtitularidaddemarca: Number(marcas[i].titularidad),
                            registrosi: si, registrono: no, productor: marcas[i].productorautorizado, maquilador: marcas[i].maquiladorautorizado,
                            isbaja: marcas[i].isbaja, alta: marcas[i].alta, baja: marcas[i].baja, relacioncontacto: marcas[i].idmarcascliente,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcas[i].iscorregida == true ? true : false
                        }
                        await axios.post(urlAgregarMarca, { data: data })
                    }
                }
                for (const i in marcasBebidas) {
                    const { id, fc_36_archivosmarcasproducto, marcaregistrada, ...anexo } = marcasBebidas[i]
                    if (anexo.idfc36_anexomarcasproductoconmezcal) {
                        let si = false
                        let no = false
                        if (marcasBebidas[i].marcaregistrada === 'Si') si = true
                        else no = true
                        anexo.si = si
                        anexo.no = no
                        let data = {
                            marca: marcasBebidas[i].nombremarca, numeroderegistroimpi: marcasBebidas[i].numeroregistro,
                            idtipomarca: Number(marcasBebidas[i].tipomarca), idtitularidaddemarca: Number(marcasBebidas[i].titularidad),
                            registrosi: si, registrono: no, productor: marcasBebidas[i].productorautorizado, maquilador: marcasBebidas[i].maquiladorautorizado,
                            isbaja: marcasBebidas[i].isbaja, alta: marcasBebidas[i].alta, baja: marcasBebidas[i].baja, relacioncontacto: marcasBebidas[i].idmarcascliente,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcasBebidas[i].iscorregida == true ? true : false,
                            idfc36_anexomarcasproductoconmezcal: anexo.idfc36_anexomarcasproductoconmezcal
                        }
                        await axios.put(urlActualizarMarcaBebida, { data: data })
                    } else {
                        let si = false
                        let no = false
                        if (marcasBebidas[i].marcaregistrada === 'Si') si = true
                        else no = true
                        let data = {
                            marca: marcasBebidas[i].nombremarca, numeroderegistroimpi: marcasBebidas[i].numeroregistro,
                            idtipomarca: Number(marcasBebidas[i].tipomarca), idtitularidaddemarca: Number(marcas[i].titularidad),
                            registrosi: si, registrono: no, productor: marcasBebidas[i].productorautorizado, maquilador: marcasBebidas[i].maquiladorautorizado,
                            isbaja: marcasBebidas[i].isbaja, alta: marcasBebidas[i].alta, baja: marcasBebidas[i].baja, relacioncontacto: marcasBebidas[i].idmarcasproductocliente,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, iscorregida: marcasBebidas[i].iscorregida == true ? true : false
                        }
                        await axios.post(urlAgregarMarcaBebida, { data: data })
                    }
                }
            }
            if (solicitud.data.actualizacioncadena || solicitud.data.actualizacionprediosviveros) {
                for (const i in viveros) {
                    const { id, fc_36archivovivero, domicilio, ...anexo } = viveros[i]
                    if (anexo.idfc_36_anexoviveros) {
                        if (viveros?.[i]?.cultivado == 'Si') anexo.cultivado = true
                        else anexo.cultivado = false
                        if (viveros?.[i]?.semicultivado == 'Si') anexo.semicultivado = true
                        else anexo.semicultivado = false
                        if (viveros?.[i]?.silvestre == 'Si') anexo.silvestre = true
                        else anexo.silvestre = false
                        let actu = await axios.put(urlActualizarViveros, { data: anexo })
                    } else {
                        let cultivado = false
                        let semicultivado = false
                        let silvestre = false
                        if (viveros?.[i]?.cultivado == 'Si') cultivado = true
                        if (viveros?.[i]?.semicultivado == 'Si') semicultivado = true
                        if (viveros?.[i]?.silvestre == 'Si') silvestre = true

                        let data = {
                            cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                            nombreparaje: viveros[i].nombreparaje, localidad: viveros[i].localidad,
                            municipio: viveros[i].municipio, distrito: viveros[i].distrito,
                            estado: viveros[i].estado, calle: viveros[i].calle,
                            numeroexterior: viveros[i].numeroexterior, codigopostal: viveros[i].codigopostal,
                            alta: viveros[i].alta, baja: viveros[i].baja, relacioncontacto: viveros[i].idvivero,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: false
                        }
                        await axios.post(urlViveros, { data: data })
                    }
                }
                for (const i in predios) {
                    const { id, fc_36archivopredio, domicilio, ...anexo } = predios[i]
                    if (anexo.idfc36_anexopredio) {
                        if (predios?.[i]?.cultivado == 'Si') anexo.cultivado = true
                        else anexo.cultivado = false
                        if (predios?.[i]?.semicultivado == 'Si') anexo.semicultivado = true
                        else anexo.semicultivado = false
                        if (predios?.[i]?.silvestre == 'Si') anexo.silvestre = true
                        else anexo.silvestre = false
                        let act = await axios.put(urlActualizarPredios, { data: anexo })
                    } else {
                        let cultivado = false
                        let semicultivado = false
                        let silvestre = false
                        if (predios?.[i]?.cultivado == 'Si') cultivado = true
                        if (predios?.[i]?.semicultivado == 'Si') semicultivado = true
                        if (predios?.[i]?.silvestre == 'Si') silvestre = true

                        let data = {
                            cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                            nombreparaje: predios[i].nombreparaje, localidad: predios[i].localidad,
                            municipio: predios[i].municipio, distrito: predios[i].distrito,
                            estado: predios[i].estado, calle: predios[i].calle,
                            alta: predios[i].alta, baja: predios[i].baja, relacioncontacto: predios[i].idpredio,
                            idfc36_solicitudactualizacion: idfc36_solicitudactualizacion, isbaja: false
                        }
                        await axios.post(urlPredios, { data: data })
                    }
                }
            }
            if (solicitud.data?.actualizacioncadena) {
                //Instalaciones
                for (let i in instalaciones) {

                    const { id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID } = instalaciones[i].data
                    for (let x in anexoInstalacionSinID) {
                        if (anexoInstalacionSinID[x] === "") {
                            anexoInstalacionSinID[x] = null
                        }
                    }
                    if (tipoInstalacion === 'Unidad Producción') {
                        
                        if (anexoInstalacionSinID.idfc_36anexo) {
                            const { idfc36_solicitudactualizacion, idfc_36anexo, fc_36instalaciones, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                            const idInfoGeneral = indormacionGeneralActualizada.data.data.idfc_36informaciongeneral

                            for (const responsable of responsables) {
                                if (responsable.idfc_36responsabledeinstalacion) {
                                    const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idInfoGeneral
                                    if (responsableSinID.nombreresponsable !== '') {
                                        await axios.put(urlActualizarResponsable, { data: responsableSinID })
                                    }
                                } else {
                                    const { id, estado, idfc_36informaciongeneral, idfc_36responsabledeinstalacion, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idInfoGeneral
                                }
                            }
                            if (dataSeccion?.coccionProduccion) {
                                for (const elemento of dataSeccion.coccionProduccion) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.moliendaProduccion) {
                                for (const elemento of dataSeccion.moliendaProduccion) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.fermentacionProduccion) {
                                for (const elemento of dataSeccion.fermentacionProduccion) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.destilacionProduccion) {
                                for (const elemento of dataSeccion.destilacionProduccion) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                        } else {
                            const { idfc36_solicitudactualizacion, isbaja, baja, alta, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                            const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                            let dataInstalacion = {
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                idtipoinstalacion: 1,
                            }
                            await axios.post(urlInstalacion, { data: dataInstalacion })

                            const data = {
                                idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                                idtipoanexo: 1,
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                isbaja: isbaja, alta: alta, baja: baja
                            }
                            const anexoAgregado = await axios.post(urlAnexo, { data })
                            const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo
                            for (const responsable of responsables) {
                                const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                                if (responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, { data: responsableSinID })
                                }
                            }
                            for (const elemento of dataSeccion.coccionProduccion) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.moliendaProduccion) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.fermentacionProduccion) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.destilacionProduccion) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                    }
                    if (tipoInstalacion === 'Unidad Envasado') {
                        if (anexoInstalacionSinID.idfc_36anexo) {

                            const { idfc36_solicitudactualizacion, idfc_36anexo, fc_36instalaciones, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                            const idInfoGeneral = indormacionGeneralActualizada.data.data.idfc_36informaciongeneral

                            for (const responsable of responsables) {
                                if (responsable.idfc_36responsabledeinstalacion) {
                                    const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idInfoGeneral
                                    if (responsableSinID.nombreresponsable !== '') {
                                        await axios.put(urlActualizarResponsable, { data: responsableSinID })

                                    }
                                } else {
                                    const { id, estado, idfc_36informaciongeneral, idfc_36responsabledeinstalacion, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idInfoGeneral
                                    if (responsableSinID.nombreresponsable !== '') {
                                        const resAnexo = await axios.post(urlResponsable, { data: responsableSinID })
                                    }
                                }

                            }
                            if (dataSeccion?.seccion1) {
                                for (const elemento of dataSeccion.seccion1) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.seccion2) {
                                for (const elemento of dataSeccion.seccion2) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.seccion3) {
                                for (const elemento of dataSeccion.seccion3) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.seccion4) {
                                for (const elemento of dataSeccion.seccion4) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.seccion5) {
                                for (const elemento of dataSeccion.seccion5) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                        } else {
                            const { idfc36_solicitudactualizacion, isbaja, alta, baja, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                            const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                            let dataInstalacion = {
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                idtipoinstalacion: 2,
                            }
                            await axios.post(urlInstalacion, { data: dataInstalacion })
                            const data = {
                                idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                                idtipoanexo: 2,
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                isbaja: isbaja, alta: alta, baja: baja
                            }
                            const anexoAgregado = await axios.post(urlAnexo, { data })
                            const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo
                            for (const responsable of responsables) {
                                const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                                if (responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, {
                                        data: responsableSinID
                                    })
                                }
                            }
                            for (const elemento of dataSeccion.seccion1) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.seccion2) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.seccion3) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.seccion4) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.seccion5) {
                                const { id, opcion, capacidad, ...dataElemento } = elemento
                                dataElemento.idfc_36anexo = idfc_36anexo
                                if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                    }
                    if (tipoInstalacion === 'Unidad Almacén') {

                        if (anexoInstalacionSinID.idfc_36anexo) {
                            const { tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado, idfc36_solicitudactualizacion, idfc_36anexo, fc_36instalaciones, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                            const idfc_36informaciongeneral = indormacionGeneralActualizada.data.data.idfc_36informaciongeneral
                            const idInfoGeneral = indormacionGeneralActualizada.data.data.idfc_36informaciongeneral
                            const urlEliminarInstalaciones = host + `FC_01/eliminarInstalaciones/${idfc_36informaciongeneral}`
                            await axios.delete(urlEliminarInstalaciones)
                            if (tipoinstalacionbodega) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 3,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            if (tipoinstalaciongranel) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 4,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            if (tipoinstalacionmaduracion) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 5,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            for (const responsable of responsables) {
                                if (responsable.idfc_36responsabledeinstalacion) {
                                    const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                                    if (responsableSinID.nombreresponsable !== '') {
                                        await axios.put(urlActualizarResponsable, { data: responsableSinID })
                                    }
                                } else {
                                    const { id, estado, idfc_36informaciongeneral, idfc_36responsabledeinstalacion, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                    responsableSinID.idfc_36informaciongeneral = idInfoGeneral
                                    if (responsableSinID.nombreresponsable !== '') {
                                        const resAnexo = await axios.post(urlResponsable, { data: responsableSinID })
                                    }
                                }
                            }
                            if (dataSeccion?.equipoAlmacen) {
                                for (const elemento of dataSeccion.equipoAlmacen) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.granelAlmacen) {
                                for (const elemento of dataSeccion.granelAlmacen) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.maduracionAlmacen) {
                                for (const elemento of dataSeccion.maduracionAlmacen) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }
                                }
                            }
                            if (dataSeccion?.variablesAlmacen) {
                                for (const elemento of dataSeccion.variablesAlmacen) {
                                    if (elemento.iddataelemento) {
                                        const { id, opcion, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                    } else {
                                        const { id, opcion, iddataelemento, ...dataElemento } = elemento
                                        dataElemento.idfc_36anexo = idfc_36anexo
                                        if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                        if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                    }

                                }
                            }
                        } else {
                            const { tipoinstalacionanejamiento, tipoinstalacionbodega,
                                tipoinstalaciongranel, tipoinstalacionmaduracion,
                                tipoinstalacionreposado, idfc36_solicitudactualizacion,
                                isbaja, alta, baja, ...unidad } = anexoInstalacionSinID
                            const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                            const idfc_36informaciongeneral = indormacionGeneralAgregada.data.data.idfc_36informaciongeneral
                            if (tipoinstalacionbodega) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 3,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            if (tipoinstalaciongranel) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 4,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            if (tipoinstalacionmaduracion) {
                                const data = {
                                    idfc_36informaciongeneral: idfc_36informaciongeneral,
                                    idtipoinstalacion: 5,
                                }
                                await axios.post(urlInstalacion, { data })
                            }
                            for (const responsable of responsables) {
                                const { id, estado, fc_36_archivosresposansables, ...responsableSinID } = responsable
                                responsableSinID.idfc_36informaciongeneral = idfc_36informaciongeneral
                                if (responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, {
                                        data: responsableSinID
                                    })
                                }
                            }
                            const data = {
                                idfc36_solicitudactualizacion: res.data.data.idfc36_solicitudactualizacion,
                                idtipoanexo: 3,
                                idfc_36informaciongeneral: idfc_36informaciongeneral,
                                isbaja: isbaja, alta: alta, baja: baja
                            }
                            const anexoAgregado = await axios.post(urlAnexo, { data })
                            const idfc_36anexo = anexoAgregado.data.data.idfc_36anexo

                            if (tipoinstalacionbodega) {
                                for (const elemento of dataSeccion.equipoAlmacen) {
                                    const { id, opcion, capacidad, ...dataElemento } = elemento
                                    dataElemento.idfc_36anexo = idfc_36anexo
                                    if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                            }
                            if (tipoinstalaciongranel) {
                                for (const elemento of dataSeccion.granelAlmacen) {
                                    const { id, opcion, capacidad, ...dataElemento } = elemento
                                    dataElemento.idfc_36anexo = idfc_36anexo
                                    if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                            }
                            if (tipoinstalacionmaduracion) {
                                for (const elemento of dataSeccion.maduracionAlmacen) {
                                    const { id, opcion, capacidad, ...dataElemento } = elemento
                                    dataElemento.idfc_36anexo = idfc_36anexo
                                    if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                            }
                            if (tipoinstalacionmaduracion) {
                                for (const elemento of dataSeccion.variablesAlmacen) {
                                    const { id, opcion, capacidad, ...dataElemento } = elemento
                                    dataElemento.idfc_36anexo = idfc_36anexo
                                    if (dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if (opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                            }
                        }
                    }
                }
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_36Estatus = createAsyncThunk(
    ACTUALIZAR_FC_36_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarFileFC_36 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_36_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_36 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_36_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

    return resFile
}

export const obtenerSeccionesEnvasado = createAsyncThunk(
    OBTENER_FC_36_SECCIONESUNIDADENVASADO_EXITO,
    async (idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_36/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSeccionesDeProduccion = createAsyncThunk(
    OBTENER_FC_36_SECCIONES_EXITO_BD,
    async (idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_36/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSeccionesAlmacen = createAsyncThunk(
    OBTENER_FC_36_SECCIONESUNIDADALMACEN_EXITO,
    async (idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_36/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFileFC_36 = createAsyncThunk(
    ELIMINAR_ARCHIVO_FC_36_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await axios.delete(host + ruta + "/" + archivo.idAnexo)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_36Map = createAsyncThunk(
    OBTENER_FC_36_MAP_EXITO_CLIENTE,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_36_SolicitudDeActualizacionMap/${solicitudId}`
            const res = await axios.get(fullUrl)

            const anexosMap = await obtenerAnexosMap(solicitudId)

            const solicitudMap = {
                data: res?.data?.data,
                anexoContactosMap: anexosMap?.anexoContactosMap, anexoRepresentantesMap: anexosMap?.anexoRepresentantesMap,
                anexoArchivosRepresentantesMap: anexosMap?.anexoArchivosRepresentantesMap, anexoPersonaAutorizadaMap: anexosMap?.anexoPersonaAutorizadaMap,
                anexoArchivosPersonaAutorizadaMap: anexosMap?.anexoArchivosPersonaAutorizadaMap, anexoDomicilioFiscalMap: anexosMap?.anexoDomicilioFiscalMap,
                anexoArchivosDomicilioFiscalMap: anexosMap?.anexoArchivosDomicilioFiscalMap, anexoPrediosMap: anexosMap?.anexoPrediosMap,
                anexoArchivosPrediosMap: anexosMap?.anexoArchivosPrediosMap, anexoViverosMap: anexosMap?.anexoViverosMap,
                anexoArchivosViverosMap: anexosMap?.anexoArchivosViverosMap, anexoMarcasMap: anexosMap?.anexoMarcasMap,
                anexoArchivosMarcasMap: anexosMap?.anexoArchivosMarcasMap, anexoMarcasBebidaMap: anexosMap?.anexoMarcasBebidaMap,
                anexoArchivosMarcasBebidaMap: anexosMap?.anexoArchivosMarcasBebidaMap, anexoInstalacionesMap: anexosMap?.anexoInstalacionesMap,
                anexoArchivosInstalacionesMap: anexosMap?.anexoArchivosInstalacionesMap, anexoResponsablesInstalacionesMap: anexosMap?.anexoResponsablesInstalacionesMap,
                anexoArchivosResponsablesInstalacionesMap: anexosMap?.anexoArchivosResponsablesInstalacionesMap,
                anexoResponsablesInstMap: anexosMap?.anexoResponsablesInstMap, anexoArchivosResponsablesInstMap: anexosMap?.anexoArchivosResponsablesInstMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerAnexosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_36/obtenerFormatoFC36_ConDetalle/${idSolicitud}`
        const obtenerAnexoContactosMap = host + `MapSolicitud/obtenerMapFC_36_AnexoMediosDeContactoMap/`
        const obtenerAnexoRepresentantesMap = host + `MapSolicitud/obtenerMapFC_36_AnexoRepresentantesLegalMap/`
        const obtenerArchivosRepresentantesMap = host + `MapSolicitud/obtenerMapFC_36_ArchivoRepresentantesLegalMap/`
        const obtenerAnexoPersonasAutorizadasMap = host + `MapSolicitud/obtenerMapFC_36_AnexoRepresentantesAutorizadosMap/`
        const obtenerArchivoPersonasMap = host + `MapSolicitud/obtenerMapFC_36_ArchivosRepresentantesAutorizadosMap/`
        const obtenerAnexoDomicilioMap = host + `MapSolicitud/obtenerMapFC_36_AnexoDomiciliosFiscalMap/`
        const obtenerArchivoDomicilioMap = host + `MapSolicitud/obtenerMapFC_36_ArchivoDomiciliosFiscalMap/`
        const obtenerAnexoPrediosMap = host + `MapSolicitud/obtenerFC_36_PredioMap/`
        const obtenerArchivosPrediosMap = host + `MapSolicitud/obtenerFC_36_ArchivosPredioMap/`
        const obtenerAnexoViverosMap = host + `MapSolicitud/obtenerFC_36_ViveroMap/`
        const obtenerArchivosViverosMap = host + `MapSolicitud/obtenerFC_36_ArchivosViveroMap/`
        const obtenerAnexoMarcasMap = host + `MapSolicitud/obtenerFC_36_MarcasMap/`
        const obtenerArchivosMarcasMap = host + `MapSolicitud/obtenerFC_36_ArchivosMarcasMap/`
        const obtenerAnexoMarcasBebidasMap = host + `MapSolicitud/obtenerFC_36_MarcasBebidasMap/`
        const obtenerArchivosMarcasBebidasMap = host + `MapSolicitud/obtenerFC_36_ArchivosMarcasBebidasMap/`
        const obtenerAnexoInstalacionesMap = host + `MapSolicitud/obtenerFC_36_InformacionGeneralMap/`
        const obtenerArchivosInstalacionesMap = host + `MapSolicitud/obtenerFC_36_ArchivoInstalacionMap/`
        const obtenerAnexoResponsablesInstalacionesMap = host + `MapSolicitud/obtenerFC_36_ResponsableInstalacionMap/`
        const obtenerArchivosResponsablesInstalacionesMap = host + `MapSolicitud/obtenerFC_36_ArchivosResponsableInstalacionMap/`
        const obtenerAnexosResponsablesInstMap = host + `MapSolicitud/obtenerFC_36_ActualizacionResponsablesInstalacionesMap/`
        const obtenerArchivosResponsablesInstMap = host + `MapSolicitud/obtenerFC_36_ArchivosActualizacionResponsablesInstalacionesMap/`


        const res = await axios.get(fullUrl)
        let anexoContactosMap = []
        let anexoRepresentantesMap = []
        let anexoArchivosRepresentantesMap = []
        let anexoPersonaAutorizadaMap = []
        let anexoArchivosPersonaAutorizadaMap = []
        let anexoDomicilioFiscalMap = []
        let anexoArchivosDomicilioFiscalMap = []
        let anexoPrediosMap = []
        let anexoArchivosPrediosMap = []
        let anexoViverosMap = []
        let anexoArchivosViverosMap = []
        let anexoMarcasMap = []
        let anexoArchivosMarcasMap = []
        let anexoMarcasBebidaMap = []
        let anexoArchivosMarcasBebidaMap = []
        let anexoInstalacionesMap = []
        let anexoArchivosInstalacionesMap = []
        let anexoResponsablesInstalacionesMap = []
        let anexoArchivosResponsablesInstalacionesMap = []
        let anexoResponsablesInstMap = []
        let anexoArchivosResponsablesInstMap = []

        for (const anexo of res.data.data.fc_36_anexomediosdecontacto) {
            const resMap = await axios.get(obtenerAnexoContactosMap + anexo.idfc36_anexomediodecontacto)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexomediodecontacto
                anexoContactosMap.push(resMap.data.data)
            }
        }
        for (const anexo of res.data.data.fc_36_anexoapoderadoslegales) {
            const resMap = await axios.get(obtenerAnexoRepresentantesMap + anexo.idfc36_anexoapoderadoslegales)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexoapoderadoslegales
                anexoRepresentantesMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivoresponsablelegal) {
                const resMap = await axios.get(obtenerArchivosRepresentantesMap + dato.idfc_36archivoresponsablelegal)

                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivoresponsablelegal
                    anexoArchivosRepresentantesMap.push(resMap.data.data)

                }
            }
        }

        for (const anexo of res.data.data.fc_36_anexopersonasautorizadas) {
            const resMap = await axios.get(obtenerAnexoPersonasAutorizadasMap + anexo.idfc36_anexopersonasautorizadas)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexopersonasautorizadas
                anexoPersonaAutorizadaMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivopersonasautorizadas) {
                const resMap = await axios.get(obtenerArchivoPersonasMap + dato.idfc_36archivopersonasautorizadas)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivopersonasautorizadas
                    anexoArchivosPersonaAutorizadaMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36_anexodomiciliosfiscales) {
            const resMap = await axios.get(obtenerAnexoDomicilioMap + anexo.idfc36_anexodomiciliosfiscales)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexodomiciliosfiscales
                anexoDomicilioFiscalMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivodomiciliosficales) {
                const resMap = await axios.get(obtenerArchivoDomicilioMap + dato.idfc_36archivodomiciliosfiscales)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivodomiciliosfiscales
                    anexoArchivosDomicilioFiscalMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36_anexoviveros) {
            const resMap = await axios.get(obtenerAnexoViverosMap + anexo.idfc_36_anexoviveros)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc_36_anexoviveros
                anexoViverosMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivovivero) {
                const resMap = await axios.get(obtenerArchivosViverosMap + dato.idfc_36archivovivero)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivovivero
                    anexoArchivosViverosMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36_anexopredio) {
            const resMap = await axios.get(obtenerAnexoPrediosMap + anexo.idfc36_anexopredio)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexopredio
                anexoPrediosMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivopredio) {
                const resMap = await axios.get(obtenerArchivosPrediosMap + dato.idfc_36archivopredio)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivopredio
                    anexoArchivosPrediosMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36anexo) {
            const resMap = await axios.get(obtenerAnexoInstalacionesMap + anexo.fc_36informaciongeneral.idfc_36informaciongeneral)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc_36informaciongeneral
                anexoInstalacionesMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36_archivosinstalaciones) {
                const resMap = await axios.get(obtenerArchivosInstalacionesMap + dato.idarchivosinstalacion)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idarchivosinstalacion
                    anexoArchivosInstalacionesMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36anexo) {
            for (const dato of anexo.fc_36informaciongeneral.fc_36responsablesdeinstalacion) {
                const resMap = await axios.get(obtenerAnexoResponsablesInstalacionesMap + dato.idfc_36responsabledeinstalacion)

                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36responsabledeinstalacion
                    anexoResponsablesInstalacionesMap.push(resMap.data.data)
                }
                for (const inf of dato.fc_36_archivosresposansables) {
                    const resMap = await axios.get(obtenerArchivosResponsablesInstalacionesMap + inf.idarchivosresponsables)
                    if (resMap.data.data) {
                        resMap.data.data.idAnexoBD = resMap.data.data.idarchivosresponsables
                        anexoArchivosResponsablesInstalacionesMap.push(resMap.data.data)
                    }
                }
            }

        }
        for (const anexo of res.data.data.fc_36_anexomarcas) {
            const resMap = await axios.get(obtenerAnexoMarcasMap + anexo.idfc36_anexomarcas)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexomarcas
                anexoMarcasMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36_archivosmarcas) {
                const resMap = await axios.get(obtenerArchivosMarcasMap + dato.idarchivosmarca)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idarchivosmarca
                    anexoArchivosMarcasMap.push(resMap.data.data)
                }
            }
        }

        for (const anexo of res.data.data.fc_36_anexomarcasproductoconmezcal) {
            const resMap = await axios.get(obtenerAnexoMarcasBebidasMap + anexo.idfc36_anexomarcasproductoconmezcal)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc36_anexomarcasproductoconmezcal
                anexoMarcasBebidaMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36_archivosmarcasproducto) {
                const resMap = await axios.get(obtenerArchivosMarcasBebidasMap + dato.idarchivosmarcaproducto)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idarchivosmarcaproducto
                    anexoArchivosMarcasBebidaMap.push(resMap.data.data)
                }
            }
        }
        for (const anexo of res.data.data.fc_36_actualizacionresponsableinstalaciones) {
            const resMap = await axios.get(obtenerAnexosResponsablesInstMap + anexo.idfc_36_actulizarresponsableinstalaciones)
            if (resMap.data.data) {
                resMap.data.data.idAnexoBD = resMap.data.data.idfc_36_actulizarresponsableinstalaciones
                anexoResponsablesInstMap.push(resMap.data.data)
            }
            for (const dato of anexo.fc_36archivoactualizacionresponsables) {
                const resMap = await axios.get(obtenerArchivosResponsablesInstMap + dato.idfc_36archivoresponsables)
                if (resMap.data.data) {
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_36archivoresponsables
                    anexoArchivosResponsablesInstMap.push(resMap.data.data)
                }
            }
        }

        let anexosMap = {
            anexoContactosMap, anexoRepresentantesMap,
            anexoArchivosRepresentantesMap, anexoPersonaAutorizadaMap,
            anexoArchivosPersonaAutorizadaMap, anexoDomicilioFiscalMap,
            anexoArchivosDomicilioFiscalMap, anexoPrediosMap,
            anexoArchivosPrediosMap, anexoViverosMap,
            anexoArchivosViverosMap, anexoMarcasMap,
            anexoArchivosMarcasMap, anexoMarcasBebidaMap,
            anexoArchivosMarcasBebidaMap, anexoInstalacionesMap,
            anexoArchivosInstalacionesMap, anexoResponsablesInstalacionesMap,
            anexoArchivosResponsablesInstalacionesMap,
            anexoResponsablesInstMap, anexoArchivosResponsablesInstMap
        }
        return anexosMap
    } catch (error) {
        console.log(error);
    }
}



























export const obtenerFC_36UnidadAlmacenMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_ALMACEN_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerFC_36_InformacionGeneralMap/${solicitudId}`
            const fullUrlResponsables = host + `FC_36/obtenerResponsablesInstalacionesConMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const resResponsables = await axios.get(fullUrlResponsables)
            let mapResposables = []
            for (const i in resResponsables.data.data) {
                mapResposables.push(resResponsables.data.data[i].fc_36responsablesdeinstalacionmap[0])
            }
            let result = { res: res.data.data, anexoResponsableMap: mapResposables }
            return result
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_36UnidadEnvasadoMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_ENVASADO_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerFC_36_InformacionGeneralMap/${solicitudId}`
            const fullUrlResponsables = host + `FC_36/obtenerResponsablesInstalacionesConMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const resResponsables = await axios.get(fullUrlResponsables)
            let mapResposables = []
            for (const i in resResponsables.data.data) {
                mapResposables.push(resResponsables.data.data[i].fc_36responsablesdeinstalacionmap[0])
            }
            let result = { res: res.data.data, anexoResponsableMap: mapResposables }
            return result
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_36UnidadProduccionMap = createAsyncThunk(
    OBTENER_FC_36_UNIDAD_PRODUCCION_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerFC_36_InformacionGeneralMap/${solicitudId}`
            const fullUrlResponsables = host + `FC_36/obtenerResponsablesInstalacionesConMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const resResponsables = await axios.get(fullUrlResponsables)
            let mapResposables = []
            for (const i in resResponsables.data.data) {
                mapResposables.push(resResponsables.data.data[i].fc_36responsablesdeinstalacionmap[0])
            }
            let result = { res: res.data.data, anexoResponsableMap: mapResposables }
            return result
        } catch (error) {
            console.log(error)
        }
    }
)


export const actualizarFC_36SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_36_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const marcasParaAlta = { data: data.marcasGuardadas[0] }
            const marcasParaBaja = { data: data.marcasGuardadas[1] }
            const contactosParaAlta = { data: data.contactosGuardados[0] }
            const contactosParaBaja = { data: data.contactosGuardados[1] }
            const representantesParaAlta = { data: data.representantesGuardados[0] }
            const representantesParaBaja = { data: data.representantesGuardados[1] }
            const unidadAnexoProduccionParaAlta = { data: data.fc_36AnexoUnidadProduccion }
            const unidadAnexoEnvasadoParaAlta = { data: data.fc_36AnexoUnidadEnvasado }
            const unidadAnexoAlmacenParaAlta = { data: data.fc_36AnexoUnidadAlmacen }
            let archivos = null

            if (data.archivos) {
                archivos = data.archivos
            }
            //const urlAnexoPredio = host + 'FC_06/agregarFormatoFC06AnexoPredio'
            const actualizarFC_36 = host + 'FC_36/actualizarSolicitudFC_36'

            const urlAgregarAnexosUnidadProduccion = host + 'FC_36/agregarNuevoFC_36AnexoUnidadDeProduccion'
            const urlActualizarAnexosUnidadProduccion = host + 'FC_36/actualizarAnexoUnidadDeProduccionFC_36'

            const urlAgregarAnexosUnidadEnvasado = host + 'FC_36/agregarNuevoFC_36AnexoUnidadDeEnvasado'
            const urlActualizarAnexosUnidadEnvasado = host + 'FC_36/actualizarAnexoUnidadDeEnvasadoFC_36'

            const urlAgregarAnexosUnidadAlmacen = host + 'FC_36/agregarNuevoFC_36AnexoUnidadAlmacen'
            const urlActualizarAnexosUnidadAlmacen = host + 'FC_36/actualizarAnexoUnidadDeAlmacenFC_36'

            const urlAgregarAnexosMarcas = host + 'FC_36/agregarNuevoFC_36AnexoMarcas'
            const urlActualizarAnexosMarcas = host + 'FC_36/actualizarAnexoMarcaDeSolicitudFC_36'

            const urlAgregarAnexosContactos = host + 'FC_36/agregarNuevoFC_36MediosDeContacto'
            const urlActualizarAnexosContactos = host + 'FC_36/actualizarAnexoMedioDeContactoFC_36'

            const urlAgregarAnexosRepresentantesAutorizados = host + 'FC_36/agregarNuevoFC_36AnexoRepresentantesAutorizados'
            const urlActualizarAnexosRepresentantesAutorizados = host + 'FC_36/actualizarAnexoRepresentanteAutorizadoFC_36'

            solicitud.data.fechasolicitud = new Date(solicitud.data.fechasolicitud)

            const res = await axios.put(actualizarFC_36, solicitud)
            let idfc36_solicitudactualizacion = solicitud.data.idfc36_solicitudactualizacion


            return data
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_36AnexoUnidadEnvasado = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOUNIDADENVASADO_EXITO,
    async (data) => {
        try {
            if (data.row.idfc36_anexounidaddeenvasado !== undefined) {
                const fullUrl = host + `FC_36/eliminarAnexoUnidadDeEnvasadoFC_36/${data.row.idfc36_anexounidaddeenvasado}`
                await axios.delete(fullUrl)
            }
            return data.row.id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_36AnexoUnidadProduccion = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOUNIDADPRODUCCION_EXITO,
    async (data) => {
        try {
            if (data.row.idfc36_anexounidaddeproduccion !== undefined) {
                const fullUrl = host + `FC_36/eliminarAnexoUnidadDeProduccionFC_36/${data.row.idfc36_anexounidaddeproduccion}`
                await axios.delete(fullUrl)
            }
            return data.row.id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_36AnexoUnidadAlmacen = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOUNIDADALMACEN_EXITO,
    async (data) => {
        try {
            if (data.row.idfc36_anexounidaddealmacen !== undefined) {
                const fullUrl = host + `FC_36/eliminarAnexoUnidadDeAlmacenFC_36/${data.row.idfc36_anexounidaddealmacen}`
                await axios.delete(fullUrl)
            }
            return data.row.id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_36AnexoContactoBD = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOCONTACTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarAnexoMedioDeContactoFC_36/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_36AnexoMarcaBD = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOMARCA_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarAnexoMarcaDeSolicitudFC_36/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_36AnexoRepresentanteBD = createAsyncThunk(
    ELIMINAR_FC_36_ANEXOREPRESENTANTE_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_36/eliminarAnexoRepresentanteAutorizadoFC_36/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)


export const fc36Slice = createSlice({
    name: 'fc36Slice',
    initialState: dataInicial,
    reducers: {
        editarFC_36(state, { payload }) {
            state.data = payload
            state.fc_36 = payload
        },
        agregarMediosContacto(state, { payload }) {
            state.mediosContacto.push(payload)
            state.mediosContactoDetalle = state.mediosContacto
        },
        editarMediosContacto(state, { payload }) {
            state.mediosContacto = payload
            state.mediosContactoDetalle = state.mediosContacto
        },
        agregarRepresentanteLegal(state, { payload }) {
            state.apoderadosLegales.push(payload)
            state.apoderadosDetalle = state.apoderadosLegales
        },
        editarRepresentanteLegal(state, { payload }) {
            state.apoderadosLegales = payload
            state.apoderadosDetalle = state.apoderadosLegales
        },
        agregarPersonaAutorizada(state, { payload }) {
            state.personasAutorizadas.push(payload)
            state.personasAutorizadasDetalle = state.personasAutorizadas
        },
        editarPersonaAutorizada(state, { payload }) {
            state.personasAutorizadas = payload
            state.personasAutorizadasDetalle = state.personasAutorizadas
        },
        agregarDomicilioFiscal(state, { payload }) {
            state.domiciliosFiscales.push(payload)
            state.domiciliosFiscalesDetalle = state.domiciliosFiscales
        },
        editarDomicilioFiscal(state, { payload }) {
            state.domiciliosFiscales = payload
            state.domiciliosFiscalesDetalle = state.domiciliosFiscales
        },
        agregarMarcas(state, { payload }) {
            state.marcas.push(payload)
            state.marcasDetalle = state.marcas
        },
        editarMarcas(state, { payload }) {
            state.marcas = payload
            state.marcasDetalle = state.marcas
        },
        agregarMarcasBebidas(state, { payload }) {
            state.marcasBebidas.push(payload)
            state.marcasBebidasDetalle = state.marcasBebidasDetalle
        },
        editarMarcasBebidas(state, { payload }) {
            state.marcasBebidas = payload
            state.marcasBebidasDetalle = state.marcasBebidasDetalle
        },
        agregarResponsableInstalacion(state, { payload }) {
            state.responsablesInstalaciones.push(payload)
            state.responsablesInstalacionesDetalle = state.responsablesInstalaciones
        },
        editarResponsableInstalacion(state, { payload }) {
            state.responsablesInstalaciones = payload
            state.responsablesInstalacionesDetalle = state.responsablesInstalaciones
        },
        agregarPredios(state, { payload }) {
            state.predios.push(payload)
            state.prediosDetalle = state.predios
        },
        editarPredios(state, { payload }) {
            state.predios = payload
            state.prediosDetalle = state.predios
        },
        agregarViveros(state, { payload }) {
            state.viveros.push(payload)
            state.viverosDetalle = state.viveros
        },
        editarViveros(state, { payload }) {
            state.viveros = payload
            state.viverosDetalle = state.viveros
        },
        actualizarFC_36NumeroDeUnidades(state, { payload }) {
            state.numeroDeUnidades = payload
        },
        agregarFC_36AnexoUnidadEnvasado(state, { payload }) {
            state.anexoUnidadEnvasado.push({ data: payload })
        },
        editarFC_36AnexoUnidadAlmacen(state, { payload }) {
            let index = state.anexoUnidadAlmacen.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.anexoUnidadAlmacen
            anexos[index] = { data: payload }
            state.anexoUnidadAlmacen = anexos
        },
        agregarFC_36ActividadesEmpresa(state, { payload }) {
            state.actividadesEmpresa = payload
        },
        agregarFC_36AnexoInstalacion(state, { payload }) {
            state.instalaciones.push({ data: payload })
            state.instalacionesDetalle = state.instalaciones
        },
        editarFC_36AnexoInstalacion(state, { payload }) {
            let index = state.instalaciones.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.instalaciones
            anexos[index] = { data: payload }
            state.instalaciones = anexos
            state.instalacionesDetalle = state.instalaciones
        },
        editarInstalacionBajaAlta(state, { payload }) {
            state.instalaciones = payload
            state.instalacionesDetalle = payload
        },





        setCambiosFC_36SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        setCambiosFC_36SolicitudNueva(state, { payload }) {
            state.fc_36 = payload.valores
        },
        actualizarFC_36NumeroDeUnidades(state, { payload }) {
            state.numeroDeUnidades = payload
        },
        agregarFC_36(state, { payload }) {
            state.dataDetalle = payload
            state.data = payload
            state.fc_36 = payload
        },







        actualizarModoBorradorFC_36(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_36(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarFC_36PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarFC_36PaginaActivaAlmacen(state, { payload }) {
            state.paginaActivaAlmacen = payload
        },
        actualizarFC_36PaginaActivaEnvasado(state, { payload }) {
            state.paginaActivaEnvasado = payload
        },
        actualizarFC_36PaginaActivaProduccion(state, { payload }) {
            state.paginaActivaProduccion = payload
        },
        resetDataFC_36(state, { payload }) {
            return dataInicial
        },
        eliminarFC_36AnexoInstalacion(state, { payload }) {
            state.instalaciones = state.instalaciones.filter(anexo => anexo.data.id !== payload)
        },
        limpiarMapInstalaciones(state, { payload }) {
            state.anexoUnidadProduccionMap = []
            state.anexoUnidadMap = {}
            state.anexoResponsableMap = []
        },









    },
    extraReducers: {
        [ObtenerClientePorLogin36.fulfilled]: (state, { payload }) => {
            /*if (JSON.stringify([]) != JSON.stringify(dataInicial.dataDetalle)) {
                state.data = dataInicial.dataDetalle
                state.fc_36 = dataInicial.dataDetalle
            } else {*/
            state.data = payload.fc_36
            state.fc_36 = payload.fc_36
            //}
            if (state.mediosContactoDetalle.length > 0) {
                state.mediosContacto = state.mediosContactoDetalle
            } else {
                state.mediosContacto = payload.mediosContacto
            }
            if (state.apoderadosDetalle.length > 0) {
                state.apoderadosLegales = state.apoderadosDetalle
            } else {
                state.apoderadosLegales = payload.apoderadosLegales
            }
            if (state.personasAutorizadasDetalle.length > 0) {
                state.personasAutorizadas = state.personasAutorizadasDetalle
            } else {
                state.personasAutorizadas = payload.personasAutorizadas
            }
            if (state.domiciliosFiscalesDetalle.length > 0) {
                state.domiciliosFiscales = state.domiciliosFiscalesDetalle
            } else {
                state.domiciliosFiscales = payload.domiciliosFiscales
            }
            if (state.tipoInstalacionesDetalle.length > 0) {
                state.tipoInstalaciones = state.tipoInstalacionesDetalle
            } else {
                state.tipoInstalaciones = payload.tipoInstalaciones
            }
            if (state.aliasInstalacionesDetalle.length > 0) {
                state.aliasInstalaciones = state.aliasInstalacionesDetalle
            } else {
                state.aliasInstalaciones = payload.aliasInstalaciones
            }
            if (state.responsablesInstalacionesDetalle.length > 0) {
                state.responsablesInstalaciones = state.responsablesInstalacionesDetalle
            } else {
                state.responsablesInstalaciones = payload.responsablesInstalaciones
            }
            if (state.marcasDetalle.length > 0) {
                state.marcas = state.marcasDetalle
            } else {
                state.marcas = payload.marcas
            }
            if (state.marcasBebidasDetalle.length > 0) {
                state.marcasBebidas = state.marcasBebidasDetalle
            } else {
                state.marcasBebidas = payload.marcasBebidas
            }
            if (state.instalacionesDetalle.length > 0) {
                state.instalaciones = state.instalacionesDetalle
                state.numeroDeUnidades = state.instalacionesDetalle.length

            } else {
                state.instalaciones = payload.anexosInstalaciones
                state.numeroDeUnidades = payload.anexosInstalaciones.length

            }
            if (state.prediosDetalle.length > 0) {
                state.predios = state.prediosDetalle
            } else {
                state.predios = payload.predios
            }
            if (state.viverosDetalle.length > 0) {
                state.viveros = state.viverosDetalle
            } else {
                state.viveros = payload.viveros
            }
            state.datosLogin = payload.datosLogin[0][0]
            state.cliente = payload.cliente
        },
        [obtenerFC_36SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.dataDetalle = payload.data
            state.fc_36Detalle = payload.data
            state.dataDocumentacion = payload.data
            state.mediosContactoDetalle = payload.mediosContacto
            state.apoderadosDetalle = payload.apoderadosLegales
            state.filesApoderados = payload.documentosApoderados
            state.personasAutorizadasDetalle = payload.personasAutorizadas
            state.filesPersonasAutorizadas = payload.documentosPersonas
            state.domiciliosFiscalesDetalle = payload.domicilioFiscal
            state.filesDomiciliosFiscales = payload.documentosDomicilio
            state.tipoInstalaciones = payload.tipoInstalaciones
            state.aliasInstalaciones = payload.aliasInstalaciones
            state.responsablesInstalaciones = payload.documentosDomicilio
            state.prediosDetalle = payload.predios
            state.viverosDetalle = payload.viveros
            state.filesPredios = payload.documentosPredios
            state.filesViveros = payload.documentosvivieros
            state.opcionesFilePredio = payload.opcionesFilePredio
            state.opcionesFileVivero = payload.opcionesFileVivero
            state.numeroDeUnidades = payload.maxNumeroDeInstlacion
            state.instalacionesDetalle = payload.anexoInstalaciones
            state.filesInstalaciones = payload.documentacionInstalaciones
            state.opcionesFilesInstalaciones = payload.opcionesFileInstalacion
            state.filesResponsables = payload.documentacionResponsables
            state.filesGenerales = payload.documentosGenerales
            state.responsablesInstalacionesDetalle = payload.responsableInst
            state.filesActualizacionResponsables = payload.documentosResponsableInst
            state.marcasDetalle = payload.anexoMarcas
            state.marcasBebidasDetalle = payload.anexomarcasProductoConMezcal
            state.filesMarcas = payload.documentacionMarca
            state.filesMarcasBebidas = payload.documentacionMarcaProducto
        },
        [obtenerSeccionesEnvasado.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.seccionesEnvasado = payload
            } else {
                state.seccionesEnvasado = []
            }
        },
        [obtenerSeccionesDeProduccion.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.seccionesProduccion = payload
            } else {
                state.seccionesProduccion = []
            }
        },
        [obtenerSeccionesAlmacen.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.seccionesAlmacen = payload
            } else {
                state.seccionesAlmacen = []
            }
        },
        [obtenerFC_36Map.fulfilled]: (state, { payload }) => {
            state.fc_36Map = payload.data
            state.anexoContactosMap = payload.anexoContactosMap
            state.anexoRepresentantesMap = payload.anexoRepresentantesMap
            state.anexoArchivosRepresentantesMap = payload.anexoArchivosRepresentantesMap
            state.anexoPersonaAutorizadaMap = payload.anexoPersonaAutorizadaMap
            state.anexoArchivosPersonaAutorizadaMap = payload.anexoArchivosPersonaAutorizadaMap
            state.anexoDomicilioFiscalMap = payload.anexoDomicilioFiscalMap
            state.anexoArchivosDomicilioFiscalMap = payload.anexoArchivosDomicilioFiscalMap
            state.anexoPrediosMap = payload.anexoPrediosMap
            state.anexoArchivosPrediosMap = payload.anexoArchivosPrediosMap
            state.anexoViverosMap = payload.anexoViverosMap
            state.anexoArchivosViverosMap = payload.anexoArchivosViverosMap
            state.anexoMarcasMap = payload.anexoMarcasMap
            state.anexoArchivosMarcasMap = payload.anexoArchivosMarcasMap
            state.anexoMarcasBebidaMap = payload.anexoMarcasBebidaMap
            state.anexoArchivosMarcasBebidaMap = payload.anexoArchivosMarcasBebidaMap
            state.anexoInstalacionesMap = payload.anexoInstalacionesMap
            state.anexoArchivosInstalacionesMap = payload.anexoArchivosInstalacionesMap
            state.anexoResponsablesInstalacionesMap = payload.anexoResponsablesInstalacionesMap
            state.anexoArchivosResponsablesInstalacionesMap = payload.anexoArchivosResponsablesInstalacionesMap
            state.anexoResponsablesInstMap = payload.anexoResponsablesInstMap
            state.anexoArchivosResponsablesInstMap = payload.anexoArchivosResponsablesInstMap

        },












        [obtenerFC_36UnidadAlmacenMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadProduccionMap = payload.res
            state.anexoUnidadMap = payload.res
            state.anexoResponsableMap = payload.anexoResponsableMap
        },
        [obtenerFC_36UnidadEnvasadoMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadProduccionMap = payload.res
            state.anexoUnidadMap = payload.res
            state.anexoResponsableMap = payload.anexoResponsableMap
        },
        [obtenerFC_36UnidadProduccionMap.fulfilled]: (state, { payload }) => {
            state.anexoUnidadProduccionMap = payload.res
            state.anexoUnidadMap = payload.res
            state.anexoResponsableMap = payload.anexoResponsableMap
        },
        [registrarSolicitudFC_36Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_36SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_36Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_36SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_36AnexoUnidadProduccion.fulfilled]: (state, { payload }) => {
            state.anexoUnidadProduccion = state.anexoUnidadProduccion.filter(anexo => anexo.data.id !== payload)
        },
        [eliminarFC_36AnexoUnidadEnvasado.fulfilled]: (state, { payload }) => {
            state.anexoUnidadEnvasado = state.anexoUnidadEnvasado.filter(anexo => anexo.data.id !== payload)
        },
        [eliminarFC_36AnexoUnidadAlmacen.fulfilled]: (state, { payload }) => {
            state.anexoUnidadAlmacen = state.anexoUnidadAlmacen.filter(anexo => anexo.data.id !== payload)
        },
        [eliminarFC_36AnexoContactoBD.fulfilled]: (state, { payload }) => {
            const anexosAlta = { data: state.anexoContactos.data.filter(anexo => anexo.idfc36_anexomediodecontacto !== payload) }
            state.anexoContactos = anexosAlta
            const anexosBaja = { data: state.anexoContactosBaja.data.filter(anexo => anexo.idfc36_anexomediodecontacto !== payload) }
            state.anexoContactosBaja = anexosBaja
        },
        [eliminarFC_36AnexoMarcaBD.fulfilled]: (state, { payload }) => {
            const anexosAlta = { data: state.anexoMarcas.data.filter(anexo => anexo.idfc36_anexomarcas !== payload) }
            state.anexoMarcas = anexosAlta
            const anexosBaja = { data: state.anexoMarcasBaja.data.filter(anexo => anexo.idfc36_anexomarcas !== payload) }
            state.anexoMarcasBaja = anexosBaja
        },
        [eliminarFC_36AnexoRepresentanteBD.fulfilled]: (state, { payload }) => {
            const anexosAlta = { data: state.anexoRepresentantes.data.filter(anexo => anexo.idfc36_anexorepresentantesautorizados !== payload) }
            state.anexoRepresentantes = anexosAlta
            const anexosBaja = { data: state.anexoRepresentantesBaja.data.filter(anexo => anexo.idfc36_anexorepresentantesautorizados !== payload) }
            state.anexoRepresentantesBaja = anexosBaja
        },
    },
})

//actions
export const {
    agregarMediosContacto,
    editarMediosContacto,
    agregarRepresentanteLegal,
    editarRepresentanteLegal,
    agregarPersonaAutorizada,
    editarPersonaAutorizada,
    agregarDomicilioFiscal,
    editarDomicilioFiscal,
    agregarFC_36AnexoInstalacion,
    setCambiosFC_36SolicitudBorrador,
    setCambiosFC_36SolicitudNueva,
    actualizarFC_36NumeroDeUnidades,
    agregarMarcas, editarMarcas,
    agregarResponsableInstalacion,
    editarResponsableInstalacion,
    agregarPredios, editarPredios,
    agregarViveros, editarViveros,
    editarFC_36AnexoInstalacion,
    agregarFC_36AnexoUnidadEnvasado, editarFC_36AnexoUnidadAlmacen,
    agregarFC_36ActividadesEmpresa,
    eliminarFC_36AnexoInstalacion,
    agregarFC_36,
    agregarMarcasBebidas, editarMarcasBebidas, limpiarMapInstalaciones,

    actualizarModoBorradorFC_36,
    actualizarModoCorrecionFC_36,
    actualizarFC_36PaginaActiva,
    actualizarFC_36PaginaActivaAlmacen,
    actualizarFC_36PaginaActivaEnvasado,
    actualizarFC_36PaginaActivaProduccion,
    resetDataFC_36, editarFC_36, editarInstalacionBajaAlta
} = fc36Slice.actions

export const FC36ReducerBeneficiario = fc36Slice.reducer